/**
 * Bundle POC JavaScript
 * Handles variant selection with dependencies, image switching, and add-to-cart
 */

(function() {
  'use strict';

  // Debug flag - enable via window.bundleBuilderDebug = true
  // or localStorage.setItem('bundleBuilderDebug', 'true')
  function isDebugEnabled() {
    return (
      window.bundleBuilderDebug === true ||
      (window.localStorage && window.localStorage.getItem('bundleBuilderDebug') === 'true')
    );
  }

  // Alt tag only logging - enabled by default for bundle image work
  function isAltTagOnlyEnabled() {
    if (window.bundleBuilderAltTagOnly === false) return false;
    if (window.bundleBuilderAltTagOnly === true) return true;
    if (window.localStorage && window.localStorage.getItem('bundleBuilderAltTagOnly') === 'false') {
      return false;
    }
    if (window.localStorage && window.localStorage.getItem('bundleBuilderAltTagOnly') === 'true') {
      return true;
    }
    return true;
  }

  function infoLog(...args) {
    if (!isAltTagOnlyEnabled()) {
      console.log(...args);
    }
  }

  function warnLog(...args) {
    if (!isAltTagOnlyEnabled()) {
      console.warn(...args);
    }
  }

  function errorLog(...args) {
    if (!isAltTagOnlyEnabled()) {
      console.error(...args);
    }
  }

  function groupLog(label) {
    if (!isAltTagOnlyEnabled()) {
      console.group(label);
    }
  }

  function groupEndLog() {
    if (!isAltTagOnlyEnabled()) {
      console.groupEnd();
    }
  }

  function altTagLog(...args) {
    console.log(...args);
  }

  function altTagWarn(...args) {
    console.warn(...args);
  }

  // Combined image alt tag logging - enabled by default
  function isCombinedAltTagEnabled() {
    if (window.bundleBuilderShowCombinedAltTag === false) return false;
    if (window.bundleBuilderShowCombinedAltTag === true) return true;
    if (window.localStorage && window.localStorage.getItem('bundleBuilderShowCombinedAltTag') === 'false') {
      return false;
    }
    if (window.localStorage && window.localStorage.getItem('bundleBuilderShowCombinedAltTag') === 'true') {
      return true;
    }
    return true;
  }

  function shouldLogAltTag(signature) {
    if (!signature) return false;
    if (window.bundleBuilderLastAltTagLog === signature) return false;
    window.bundleBuilderLastAltTagLog = signature;
    return true;
  }

  // Debug logging helpers
  function debugLog(...args) {
    if (isDebugEnabled()) {
      infoLog(...args);
    }
  }

  function debugGroup(label) {
    if (isDebugEnabled()) {
      groupLog(label);
    }
  }

  function debugGroupEnd() {
    if (isDebugEnabled()) {
      groupEndLog();
    }
  }

  function debugWarn(...args) {
    if (isDebugEnabled()) {
      warnLog(...args);
    }
  }

  // Always-on debug logger for cart/discount diagnostics.
  // This bypasses alt-tag-only suppression when bundleBuilderDebug is enabled.
  function discountDebugLog(...args) {
    if (isDebugEnabled()) {
      console.log(...args);
    }
  }

  // Cached jQuery selectors to avoid repeated DOM queries during navigation
  let cachedGallery = null;
  let cachedThumbs = null;

  function getGalleryElements() {
    const $ = window.jQuery;
    if (!$) return { $gallery: null, $thumbs: null };

    if (!cachedGallery || !cachedGallery.length) {
      cachedGallery = $('.js-product-gallery');
    }
    if (!cachedThumbs || !cachedThumbs.length) {
      cachedThumbs = $('.product_gallery_nav');
    }

    return { $gallery: cachedGallery, $thumbs: cachedThumbs };
  }

  /**
   * Normalize image sources on a gallery cell and its matching thumbnail so
   * src/srcset/data-srcset don’t keep stale Shopify URLs from prior renders.
   */
  function normalizeGalleryMediaSources(imageData) {
    if (!imageData || !imageData.id || !imageData.src) return;
    const zoomSrc = imageData.src.replace(/width=\d+/, 'width=5000');

    const { $gallery, $thumbs } = getGalleryElements();

    const $cellImg = $gallery ? $gallery.find(`[data-image-id="${imageData.id}"]`).first() : null;
    if ($cellImg && $cellImg.length) {
      $cellImg.attr('src', imageData.src);
      $cellImg.attr('data-src', imageData.src);
      $cellImg.removeAttr('data-srcset');
      $cellImg.removeAttr('data-sizes');
      $cellImg.attr('srcset', '');
      $cellImg.attr('data-zoom-src', zoomSrc);
    }

    const $thumbImg = $thumbs ? $thumbs.find(`[data-image-id="${imageData.id}"]`).first() : null;
    if ($thumbImg && $thumbImg.length) {
      const thumbSrc = imageData.src.includes('width=')
        ? imageData.src.replace(/width=\d+/, 'width=300')
        : `${imageData.src}${imageData.src.includes('?') ? '&' : '?'}width=300`;
      $thumbImg.attr('src', thumbSrc);
      $thumbImg.removeAttr('srcset');
      $thumbImg.removeAttr('data-srcset');
      $thumbImg.removeAttr('data-sizes');
    }
  }

  // Global queue to handle snippet calls before this script loads
  window.bundleBuilderInitQueue = window.bundleBuilderInitQueue || [];


  /**
   * Rebuild product gallery and thumbnails from bundleBaseProduct data.
   * Exposed on window as bundleBuilderInitGallery for the Liquid snippet to call.
   * 
   * NOTE: This function rebuilds the gallery from window.bundleBaseProduct.images,
   * which is set server-side from Liquid template data (base_product.images).
   * If Shopify's theme cache is serving a cached page, new images added to the
   * product won't appear until the cache is cleared or the page is hard-refreshed.
   * The gallery itself is not cached - it rebuilds from scratch each time.
   */
  function initBundleGallery(bundleBaseProduct, baseIndex = 0) {
    const bootstrap = () => {
      // Wait for DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
        return;
      }

      const $ = window.jQuery;
      if (!$) {
        setTimeout(bootstrap, 100);
        return;
      }

      if (!bundleBaseProduct || !bundleBaseProduct.images || !bundleBaseProduct.images.length) {
        return;
      }

      const $gallery = $('.js-product-gallery');
      if (!$gallery.length) {
        return;
      }

      const baseImages = bundleBaseProduct.images;
      const existingCount = $gallery.find('.gallery-cell').length;
      const existingMediaCount = parseInt($gallery.attr('data-media-count') || '0', 10);

      // Destroy Flickity before DOM mutations
      if (window.Flickity && window.Flickity.data($gallery[0])) {
        const flickityInstance = window.Flickity.data($gallery[0]);
        flickityInstance.destroy();
      }

      const $thumbnailNav = $('.product_gallery_nav');
      if ($thumbnailNav.length && window.Flickity && window.Flickity.data($thumbnailNav[0])) {
        const thumbnailFlickityInstance = window.Flickity.data($thumbnailNav[0]);
        thumbnailFlickityInstance.destroy();
      }

      // Rebuild gallery from scratch
      $gallery.empty();
      const lightboxEnabled = $gallery.data('product-lightbox') === 'true' || $gallery.data('product-lightbox') === true;
      const galleryFragment = document.createDocumentFragment();

      baseImages.forEach((image, index) => {
        const cell = document.createElement('div');
        cell.className = 'gallery-cell';
        cell.setAttribute('data-product-id', bundleBaseProduct.id);
        cell.setAttribute('data-media-type', 'image');

        if (image.component_tags && image.component_tags.length > 0) {
          cell.setAttribute('data-component-tags', image.component_tags.join(','));
        }

        const imgHtml = '<div class="image__container" style="max-width: ' + (image.width || '2048') + 'px"><img src="' + image.src + '" alt="' + image.alt + '" class="product-gallery__image lazyload" data-image-id="' + image.id + '" data-index="' + index + '" data-src="' + image.src + '"' + (image.component_tags && image.component_tags.length > 0 ? ' data-component-tags="' + JSON.stringify(image.component_tags).replace(/"/g, '&quot;') + '"' : '') + ' /></div>';

        if (lightboxEnabled) {
          cell.innerHTML = '<a href="' + image.src.replace('width=2000', 'width=5000') + '" class="lightbox" data-fancybox="' + bundleBaseProduct.id + '" data-caption="Pinch To Zoom" rel="product-lightbox" tabindex="-1"><span class="pdp-zoom-icon"></span>' + imgHtml + '</a>';
        } else {
          cell.innerHTML = imgHtml;
        }

        galleryFragment.appendChild(cell);
      });

      $gallery[0].appendChild(galleryFragment);
      $gallery.attr('data-media-count', baseImages.length);

      // Rebuild thumbnails
      if ($thumbnailNav.length) {
        const thumbFragment = document.createDocumentFragment();
        $thumbnailNav.empty();

        baseImages.forEach((image, index) => {
          const thumb = document.createElement('div');
          thumb.setAttribute('tabindex', '0');
          thumb.className = 'gallery-cell product-gallery__thumbnail';
          thumb.setAttribute('data-title', image.alt);
          thumb.setAttribute('data-index', index);

          let thumbnailSrc = image.src;
          if (thumbnailSrc.includes('width=')) {
            thumbnailSrc = thumbnailSrc.replace(/width=\d+/, 'width=300');
          } else {
            thumbnailSrc = thumbnailSrc.split('?')[0] + '?width=300';
          }

          thumb.innerHTML = '<img src="' + thumbnailSrc + '" alt="' + image.alt.replace(/"/g, '&quot;') + '" data-image-id="' + image.id + '">';
          thumbFragment.appendChild(thumb);
        });

        $thumbnailNav[0].appendChild(thumbFragment);
        $thumbnailNav.attr('data-media-count', baseImages.length);
      }

      // Reinitialize gallery
      setTimeout(() => {
        let flickityInstance = null;
        try {
          // Only reinitialize if we actually have cells
          const hasCells = $gallery.find('.gallery-cell').length > 0;
          if (!hasCells) {
          warnLog('⚠️ Skipping Flickity init: no gallery cells found');
          } else {
            // Destroy any existing instance before re-init to avoid double-inits
            if (window.Flickity) {
              const existingInstance = window.Flickity.data($gallery[0]);
              if (existingInstance && typeof existingInstance.destroy === 'function') {
                existingInstance.destroy();
              }
            }

            // Always reinitialize after rebuilding DOM
            if (window.productPage && typeof window.productPage.enableGallery === 'function') {
              window.productPage.enableGallery($gallery);
              flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
            } else if (window.Flickity) {
              const galleryData = $gallery.data();
              $gallery.flickity({
                cellSelector: '.gallery-cell',
                imagesLoaded: true,
                lazyLoad: 2,
                draggable: true,
                prevNextButtons: galleryData.galleryArrowsEnabled !== 'false',
                pageDots: false,
                wrapAround: true,
                adaptiveHeight: false
              });
              flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
            } else {
              warnLog('⚠️ Neither enableGallery nor Flickity available');
            }

            // Also reload thumbnail nav if it exists and has Flickity instance
            if ($thumbnailNav.length && window.Flickity) {
              const thumbInstance = window.Flickity.data($thumbnailNav[0]);
              if (thumbInstance && typeof thumbInstance.reloadCells === 'function') {
                thumbInstance.reloadCells();
                thumbInstance.resize();
              }
            }
          }
        } catch (err) {
          errorLog('❌ Error reinitializing gallery', err);
        }

        // Wait for Flickity to be fully ready before setting up sync and selecting cells
        const waitForFlickityReady = (instance, callback, maxAttempts = 20) => {
          if (!instance) {
            callback(false);
            return;
          }
          
          // Check if cells array exists and has items
          if (instance.cells && Array.isArray(instance.cells) && instance.cells.length > 0) {
            callback(true);
            return;
          }
          
          // If not ready yet, wait and retry
          if (maxAttempts > 0) {
            setTimeout(() => {
              waitForFlickityReady(instance, callback, maxAttempts - 1);
            }, 50);
          } else {
            warnLog('⚠️ Flickity cells not ready after timeout');
            callback(false);
          }
        };

        // Sync thumbnails on manual slider changes
        waitForFlickityReady(flickityInstance, (isReady) => {
          if (isReady && flickityInstance && !flickityInstance._bundleSyncHooked) {
            flickityInstance._bundleSyncHooked = true;
            flickityInstance.on('select', () => {
              const sel = flickityInstance.selectedElement;
              const selId = sel && sel.querySelector('[data-image-id]')
                ? sel.querySelector('[data-image-id]').dataset.imageId
                : null;
              syncThumbnails(selId, flickityInstance.selectedIndex);
            });
            
            // Fix Fancybox close issue: Theme hides/shows gallery, breaking Flickity positioning
            if (lightboxEnabled && window.jQuery && window.jQuery.fancybox) {
              $(document).on('afterClose.fb', function(e, instance) {
                const $trigger = instance && instance.$trigger ? instance.$trigger.first() : null;
                const isGallery = $trigger && $trigger.closest('.js-product-gallery').length;
                
                if ($trigger && isGallery && flickityInstance) {
                  const savedIndex = flickityInstance.selectedIndex;

                  // Full reset: destroy and re-init Flickity to clear bad positions caused by hide/show
                  setTimeout(() => {
                    const options = flickityInstance.options || {};
                    const $gallery = $trigger.closest('.js-product-gallery');
                    const hasCells = $gallery.find('.gallery-cell').length > 0;

                    if (!hasCells) {
                      warnLog('⚠️ Fancybox close: skipping Flickity reset, no gallery cells');
                      return;
                    }

                    try {
                      flickityInstance.destroy();
                      $gallery.flickity(options);
                      const newInstance = window.Flickity && window.Flickity.data($gallery[0]);
                      if (newInstance) {
                        flickityInstance = newInstance;
                        // Wait for cells before selecting
                        waitForFlickityReady(newInstance, (ready) => {
                          if (!ready) return;
                          newInstance.select(savedIndex, false, true);
                          if (typeof newInstance.positionSliderAtSelected === 'function') {
                            newInstance.positionSliderAtSelected();
                          }

                          // Fix thumbnails nav if present
                          const { $thumbs } = getGalleryElements();
                          if ($thumbs && $thumbs.length && window.Flickity) {
                            const navInstance = window.Flickity.data($thumbs[0]);
                            if (navInstance) {
                              navInstance.select(savedIndex, false, true);
                            }
                          }

                          // Sync to correct variant image after re-init
                          setTimeout(() => {
                            if (typeof window.scheduleNavigateToOptionalComponentImage === 'function') {
                              window.scheduleNavigateToOptionalComponentImage();
                            }
                          }, 50);
                        });
                      }
                    } catch (err) {
                      errorLog('❌ Failed to reset Flickity after Fancybox close', err);
                    }
                  }, 150);
                } else {
                  infoLog('Fancybox afterClose: Not our gallery or no Flickity instance');
                }
              });
            }
          }
        });

        // Switch to currently selected base variant image
        if (bundleBaseProduct.variants && bundleBaseProduct.variants.length > 0) {
          const baseVariantSelect = document.querySelector(`#variant-select-${baseIndex}`);
          let selectedVariantId = null;
          if (baseVariantSelect) {
            selectedVariantId = parseInt(baseVariantSelect.value, 10) || null;
          }
          if (!selectedVariantId) {
            selectedVariantId = bundleBaseProduct.variants[0].id;
          }

          const selectedVariant = bundleBaseProduct.variants.find(v => v.id === selectedVariantId) || bundleBaseProduct.variants[0];

          if (selectedVariant && selectedVariant.featured_media && selectedVariant.featured_media.id) {
            waitForFlickityReady(flickityInstance, (isReady) => {
              if (!isReady) return;
              
              if (typeof switchProductImage === 'function') {
                switchProductImage(selectedVariant.featured_media.id);
              } else {
                const $targetSlide = $gallery.find(`[data-image-id="${selectedVariant.featured_image_id}"]`).closest('.gallery-cell');
                const currentFlickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
                if (currentFlickityInstance && $targetSlide.length) {
                  // Use the safer selectFlickityCell function instead of direct selectCell
                  const targetIndex = Array.from($gallery.find('.gallery-cell')).indexOf($targetSlide[0]);
                  selectFlickityCell(currentFlickityInstance, $targetSlide[0], targetIndex, selectedVariant.featured_image_id);
                }
              }
            });
          }
        }
      }, 100);
    };

    bootstrap();
  }

  // Expose to window for Liquid snippet bootstrap
  window.bundleBuilderInitGallery = initBundleGallery;

  // Drain any queued calls from snippets that executed before this script loaded
  if (Array.isArray(window.bundleBuilderInitQueue) && window.bundleBuilderInitQueue.length > 0) {
    window.bundleBuilderInitQueue.forEach(args => {
      try {
        initBundleGallery.apply(null, args);
      } catch (e) {
      errorLog('bundleBuilderInitGallery queue error', e);
      }
    });
    window.bundleBuilderInitQueue.length = 0;
  }

  // Select a Flickity cell by index.
  function selectFlickityCell(flickityInstance, cellElement, fallbackIndex, imageId) {
    if (!flickityInstance) {
      return false;
    }
    
    if (!flickityInstance.cells || !Array.isArray(flickityInstance.cells) || flickityInstance.cells.length === 0) {
      return false;
    }
    
    // Find target index
    let targetIndex = -1;
    if (cellElement) {
      targetIndex = flickityInstance.cells.findIndex(cell => cell.element === cellElement);
    }
    if (targetIndex === -1 && typeof fallbackIndex === 'number' && fallbackIndex >= 0) {
      targetIndex = fallbackIndex;
    }
    
    if (targetIndex < 0 || targetIndex >= flickityInstance.cells.length) {
      return false;
    }
    
    try {
      // Stop any animations
      if (flickityInstance.isAnimating) {
        flickityInstance.stopPlayer();
      }
      
      // Select the target cell (no animation, no wrapping)
      flickityInstance.select(targetIndex, false, true);
      
      // Reposition to ensure visual matches selectedIndex
      if (typeof flickityInstance.positionSliderAtSelected === 'function') {
        flickityInstance.positionSliderAtSelected();
      }
      
      syncThumbnails(imageId, targetIndex);
      
      return true;
    } catch (err) {
      errorLog('❌ selectFlickityCell error:', err);
      return false;
    }
  }

  /**
   * Keep thumbnails Flickity in sync with main gallery selection.
   */
  function syncThumbnails(imageId, indexFallback) {
    const { $thumbs } = getGalleryElements();
    if (!$thumbs || !$thumbs.length || !window.Flickity) return;
    const navInstance = window.Flickity.data($thumbs[0]);
    if (!navInstance) return;

    let targetCell = null;
    if (imageId) {
      targetCell = $thumbs.find(`[data-image-id="${imageId}"]`).closest('.gallery-cell')[0];
    }

    if (targetCell) {
      navInstance.selectCell(targetCell, false, true);
    } else if (typeof indexFallback === 'number' && indexFallback >= 0) {
      navInstance.select(indexFallback, false, true);
    }
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleBuilder);
  } else {
    initBundleBuilder();
  }

  function initBundleBuilder() {
    debugGroup('🔍 BUNDLE BUILDER JS - Initialization');
    
    const bundleBuilder = document.querySelector('.bundle-builder');
    if (!bundleBuilder) {
      errorLog('❌ Bundle builder element not found');
      debugGroupEnd();
      return;
    }

    const configScript = document.getElementById('bundle-config-poc');
    if (!configScript) {
      errorLog('❌ Bundle config script not found');
      debugGroupEnd();
      return;
    }

    markGalleryInit();

    let bundleConfig;
    try {
      bundleConfig = JSON.parse(configScript.textContent);
    } catch (e) {
      errorLog('❌ Failed to parse bundle config:', e);
      debugGroupEnd();
      return;
    }
    const configuredBaseIndex = Number(bundleConfig.base_component_index);
    const fallbackBaseIndex = bundleConfig.components.findIndex(component => component && component.is_base);
    const baseComponentIndex = Number.isInteger(configuredBaseIndex) && configuredBaseIndex >= 0
      ? configuredBaseIndex
      : fallbackBaseIndex;

    const SPECIAL_QTY_MAPPING_BUNDLE_HANDLE = 'backcountry-pannier-kit-v2-5-bundle-product';
    const isSpecialQtyMappingBundle = (bundleConfig.bundle_product_handle || '') === SPECIAL_QTY_MAPPING_BUNDLE_HANDLE;

    const addToCartBtn = document.getElementById('add-bundle-to-cart-poc');
    const errorDiv = document.getElementById('bundle-error-poc');

    // Proactively try to (re)initialize Flickity on page load
    startFlickityInitLoop();

    // Preserve original quantity configs for reset (allowed_quantities/default_qty/labels)
    const originalQuantityConfig = bundleConfig.components.map(comp => ({
      allowed_quantities: comp.allowed_quantities,
      default_qty: comp.default_qty,
      quantity_labels: comp.quantity_labels
    }));

    // Components participating in shared Aux Pox control (handle-agnostic via shared_qty_role)
    const sharedQtyComponents = bundleConfig.components
      .map((comp, idx) => ({ comp, idx }))
      .filter(({ comp }) => typeof comp.shared_qty_role === 'string' && comp.shared_qty_role.length > 0);

    // Track shared Aux selection (0/2/4 visible values)
    let sharedAuxSelectedValue = 0;

    // Helper function to get button text element and default label
    function getButtonTextElement(button) {
      if (!button) return null;
      return button.querySelector('.text');
    }
    
    function getButtonLabel(button) {
      if (!button) return 'Add to Cart';
      return button.getAttribute('data-label') || 'Add to Cart';
    }

    // Reset button state if stuck in "Adding..." (e.g., from browser back button)
    const buttonTextEl = getButtonTextElement(addToCartBtn);
    if (addToCartBtn && buttonTextEl && buttonTextEl.textContent.trim() === 'Adding...') {
      addToCartBtn.disabled = false;
      buttonTextEl.textContent = getButtonLabel(addToCartBtn);
    }

    // Track selected variants for each component
    const selectedVariants = {};
    // Track selected quantities for each component
    const selectedQuantities = {};

    /**
     * Shared Aux Pox helpers (handle-agnostic via shared_qty_role).
     * Presents a single 0/2/4 control and maps to component quantities.
     */
    const sharedAuxDisplayOptions = [
      { value: 0, label: 'No Aux Pox' },
      { value: 2, label: 'Two Aux Pox' },
      { value: 4, label: 'Four Aux Pox' }
    ];

    function parseAllowedQuantities(component) {
      if (!component || !component.allowed_quantities) return [];
      return component.allowed_quantities
        .split(',')
        .map(q => parseInt(q.trim(), 10))
        .filter(q => !isNaN(q));
    }

    function coerceQuantity(component, desired) {
      const allowed = parseAllowedQuantities(component);
      if (!allowed.length) return desired;
      if (allowed.includes(desired)) return desired;
      return allowed.reduce((closest, current) => {
        const diffCurrent = Math.abs(current - desired);
        const diffClosest = Math.abs(closest - desired);
        if (diffCurrent === diffClosest) {
          return current > closest ? current : closest;
        }
        return diffCurrent < diffClosest ? current : closest;
      }, allowed[0]);
    }

    function getBaseVariantById(variantId) {
      const baseComponent = bundleConfig.components.find(c => c.is_base);
      if (!baseComponent) return null;
      const parsedId = parseInt(variantId, 10);
      if (Number.isNaN(parsedId)) return null;
      return baseComponent.variants.find(v => v.id === parsedId) || null;
    }

    function parseVariantTitle(variantTitle) {
      const parts = (variantTitle || '').split(' / ');
      const color = (parts[0] || '').trim();
      const sizePart = parts.length > 1 ? parts.slice(1).join(' / ').trim() : '';
      return { color, sizePart };
    }

    function classifyBaseSizeProfile(sizePart) {
      const normalized = (sizePart || '').toLowerCase();
      const has25 = /(^|[^0-9])25\s*l([^0-9]|$)|(^|[^0-9])25l([^0-9]|$)/.test(normalized);
      const has35 = /(^|[^0-9])35\s*l([^0-9]|$)|(^|[^0-9])35l([^0-9]|$)/.test(normalized);
      const isOffset = normalized.includes('offset') || (has25 && has35);

      if (isOffset) return 'offset';
      if (has25 && !has35) return 'double25';
      if (has35 && !has25) return 'double35';
      return 'unknown';
    }

    function getBaseVariantProfile(variant) {
      if (!variant) return { color: '', sizePart: '', profile: 'unknown' };
      const parsed = parseVariantTitle(variant.title);
      return {
        color: parsed.color,
        sizePart: parsed.sizePart,
        profile: classifyBaseSizeProfile(parsed.sizePart)
      };
    }

    function findBaseVariantByColorAndProfile(baseComponent, color, profile) {
      if (!baseComponent || !Array.isArray(baseComponent.variants)) return null;
      const colorLower = (color || '').toLowerCase();
      return baseComponent.variants.find(variant => {
        const variantInfo = getBaseVariantProfile(variant);
        return variantInfo.profile === profile && variantInfo.color.toLowerCase() === colorLower;
      }) || null;
    }

    function getMappedBaseCartLines(baseComponent, variantId, quantity) {
      if (!isSpecialQtyMappingBundle) {
        return [{ id: variantId, quantity }];
      }

      const baseVariant = getBaseVariantById(variantId);
      if (!baseVariant) return [{ id: variantId, quantity }];

      const variantInfo = getBaseVariantProfile(baseVariant);
      if (variantInfo.profile === 'double25' || variantInfo.profile === 'double35') {
        return [{ id: baseVariant.id, quantity: quantity * 2 }];
      }

      if (variantInfo.profile === 'offset') {
        const variant25 = findBaseVariantByColorAndProfile(baseComponent, variantInfo.color, 'double25');
        const variant35 = findBaseVariantByColorAndProfile(baseComponent, variantInfo.color, 'double35');

        if (variant25 && variant35) {
          return [
            { id: variant25.id, quantity: quantity },
            { id: variant35.id, quantity: quantity }
          ];
        }

        warnLog('⚠️ Could not map offset variant to split SKUs; using selected variant', {
          selectedVariantId: baseVariant.id,
          color: variantInfo.color,
          sizePart: variantInfo.sizePart,
          found25: !!variant25,
          found35: !!variant35
        });
      }

      return [{ id: baseVariant.id, quantity }];
    }

    function resolveBaseVariantId(baseVariantId) {
      const baseComponent = bundleConfig.components.find(c => c.is_base);
      if (!baseComponent) return null;

      const candidateIds = [
        baseVariantId,
        selectedVariants[baseComponent.index]
      ];

      const baseSelect = bundleBuilder.querySelector(`#variant-select-${baseComponent.index}`);
      if (baseSelect && baseSelect.value) {
        candidateIds.push(baseSelect.value);
      }

      for (const candidate of candidateIds) {
        const parsedId = parseInt(candidate, 10);
        if (Number.isNaN(parsedId)) continue;
        if (baseComponent.variants.some(v => v.id === parsedId)) {
          return parsedId;
        }
      }

      return null;
    }

    function getActiveAuxComponentsForBase(variantId) {
      const resolvedBaseVariantId = resolveBaseVariantId(variantId);
      const baseVariant = getBaseVariantById(resolvedBaseVariantId);
      if (!baseVariant) return sharedQtyComponents;

      if (!isSpecialQtyMappingBundle) {
        const variantTitle = baseVariant.title || '';
        const parts = variantTitle.split(' / ');
        const sizePart = parts[1] ? parts[1].trim() : '';
        const aux4 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-4l');
        const aux5 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-5l');

        if (sizePart.includes('25L + 25L') && aux4) return [aux4];
        if (sizePart.includes('35L + 35L') && aux5) return [aux5];
        if (sizePart.includes('35L + 25L') && aux4 && aux5) return [aux4, aux5];
        return sharedQtyComponents;
      }

      const { sizePart } = parseVariantTitle(baseVariant.title || '');
      const sizeProfile = classifyBaseSizeProfile(sizePart);

      const aux4 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-4l');
      const aux5 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-5l');

      if (sizeProfile === 'double25' && aux4) return [aux4];
      if (sizeProfile === 'double35' && aux5) return [aux5];
      if (sizeProfile === 'offset' && aux4 && aux5) return [aux4, aux5];

      // Fallback: return all shared components if we can't parse
      return sharedQtyComponents;
    }

    function getVariantIdForComponent(componentIndex) {
      const component = bundleConfig.components[componentIndex];
      if (!component) return null;
      if (component.component_variant_id) return component.component_variant_id;
      if (selectedVariants[componentIndex]) return selectedVariants[componentIndex];
      const compEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
      const selectEl = compEl ? compEl.querySelector(`#variant-select-${componentIndex}`) : null;
      if (selectEl && selectEl.value) {
        const parsed = parseInt(selectEl.value, 10);
        if (!Number.isNaN(parsed)) return parsed;
      }
      return null;
    }

    const inventoryCache = {};
    function getAvailabilityFromConfig(variantId) {
      const id = parseInt(variantId, 10);
      if (!id || !bundleConfig || !Array.isArray(bundleConfig.components)) return null;
      for (const component of bundleConfig.components) {
        if (!component || !Array.isArray(component.variants)) continue;
        const match = component.variants.find(v => v.id === id);
        if (match && typeof match.available === 'boolean') {
          return { available: match.available, quantity: null };
        }
      }
      return null;
    }

    function fetchVariantAvailability(variantId) {
      const id = parseInt(variantId, 10);
      if (!id) return Promise.resolve({ available: null, quantity: null });
      if (inventoryCache[id] !== undefined) return Promise.resolve(inventoryCache[id]);
      const url = `/variants/${id}.json`;
      return fetch(url, { credentials: 'same-origin' })
        .then(res => res.ok ? res.json() : Promise.reject(new Error(`Variant ${id} inventory fetch failed: ${res.status}`)))
        .then(data => {
          const variant = data && data.variant ? data.variant : {};
          const available = typeof variant.available === 'boolean' ? variant.available : null;
          const quantity = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
          let result = { available, quantity };
          if (available === null && quantity === null) {
            const fallback = getAvailabilityFromConfig(id);
            if (fallback) {
              result = fallback;
            }
          }
          inventoryCache[id] = result;
          if (isDebugEnabled() && available === null && quantity === null && result.available === null && result.quantity === null) {
            warnLog('⚠️ Inventory data missing', { variantId: id, data: variant });
          }
          return result;
        })
        .catch(err => {
          if (isDebugEnabled()) {
            warnLog('⚠️ Inventory fetch failed', { variantId: id, error: err && err.message });
          }
          const result = { available: null, quantity: null };
          inventoryCache[id] = result;
          return result;
        });
    }

    function setButtonDisabled(btn, disabled, reason) {
      if (!btn) return;
      const wasDisabled = btn.disabled;
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.classList.toggle('disabled', disabled);
      if (disabled && !wasDisabled) {
        warnLog(`⚠️ Disabled option: ${reason}`);
      }
    }

    function setComponentQuantity(componentIndex, quantity, { skipNavigation = false } = {}) {
      const component = bundleConfig.components[componentIndex];
      if (!component) return;
      selectedQuantities[componentIndex] = quantity;

      const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
      if (componentEl) {
        componentEl.querySelectorAll('.bundle-component__qty-btn').forEach(b => {
          b.classList.remove('selected');
          if (parseInt(b.dataset.quantity, 10) === quantity) {
            b.classList.add('selected');
          }
        });
        const qtyDisplay = componentEl.querySelector('.bundle-component__qty-value');
        if (qtyDisplay) {
          qtyDisplay.textContent = quantity;
        }
      }

      if (!skipNavigation && (component.role === 'optional' || component.role === 'accessory' || component.role === 'required')) {
        setTimeout(() => scheduleNavigateToOptionalComponentImage(), 100);
      }

      checkBundleReady();
      updateComponentPriceDisplay(componentIndex);
      updateComponentDiscountDisplay(componentIndex);
      updateTotalBundlePrice();
    }

    function applyInventoryGatingForComponent(componentIndex) {
      const component = bundleConfig.components[componentIndex];
      if (!component || component.is_base || !component.allowed_quantities) return;

      const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
      if (!componentEl) return;

      const variantId = getVariantIdForComponent(componentIndex);
      if (!variantId) return;

      fetchVariantAvailability(variantId).then(({ available, quantity }) => {
        if (available === null && quantity === null) return;

        const qtyButtons = componentEl.querySelectorAll('.bundle-component__qty-btn');
        qtyButtons.forEach(btn => {
          const qty = parseInt(btn.dataset.quantity, 10);
          if (Number.isNaN(qty) || qty === 0) return setButtonDisabled(btn, false, '');
          const isOut = available === false;
          const canCheckQty = typeof quantity === 'number';
          setButtonDisabled(
            btn,
            isOut || (canCheckQty && qty > quantity),
            `${component.component_product_handle} qty ${qty} (avail ${canCheckQty ? quantity : 'unknown'})`
          );
        });

        const currentQty = selectedQuantities[componentIndex] || 0;
        const isOut = available === false;
        const canCheckQty = typeof quantity === 'number';
        if ((isOut && currentQty > 0) || (canCheckQty && currentQty > quantity)) {
          const limit = isOut ? 0 : quantity;
          const allowed = parseAllowedQuantities(component).filter(q => q <= limit);
          const fallback = allowed.length ? Math.max(...allowed) : 0;
          if (fallback !== currentQty) {
            warnLog('⚠️ Adjusting quantity due to low inventory', {
              componentIndex,
              handle: component.component_product_handle,
              from: currentQty,
              to: fallback,
              available,
              quantity
            });
            setComponentQuantity(componentIndex, fallback, { skipNavigation: true });
          }
        }
      });
    }

    function getChoiceGroupItems(groupKey) {
      return bundleConfig.components
        .map((component, idx) => ({ component, idx }))
        .filter(({ component }) => component.choice_group === groupKey);
    }

    function applyInventoryGatingForChoiceGroups() {
      document.querySelectorAll('.bundle-choice-group').forEach(group => {
        const groupKey = group.dataset.choiceGroup;
        if (!groupKey) return;

        const items = getChoiceGroupItems(groupKey);
        const buttons = Array.from(group.querySelectorAll('button.swatch-element'));
        const checks = buttons.map(btn => {
          const idx = parseInt(btn.dataset.choiceIdx, 10);
          if (Number.isNaN(idx)) return Promise.resolve({ btn, idx, disabled: false });
          const variantId = getVariantIdForComponent(idx);
          if (!variantId) return Promise.resolve({ btn, idx, disabled: false });
          return fetchVariantAvailability(variantId).then(({ available, quantity }) => {
            if (available === null && quantity === null) {
              setButtonDisabled(btn, false, '');
              return { btn, idx, disabled: false };
            }
            const isOut = available === false;
            const canCheckQty = typeof quantity === 'number';
            const disabled = isOut || (canCheckQty && quantity < 1);
            setButtonDisabled(
              btn,
              disabled,
              `${bundleConfig.components[idx].component_product_handle} qty 1 (avail ${canCheckQty ? quantity : 'unknown'})`
            );
            return { btn, idx, disabled };
          });
        });

        Promise.all(checks).then(results => {
          const selectedBtn = group.querySelector('button.swatch-element.selected');
          if (selectedBtn && selectedBtn.disabled) {
            const firstEnabled = results.find(r => !r.disabled);
            if (firstEnabled) {
              setChoiceSelection(groupKey, firstEnabled.idx, items);
              group.querySelectorAll('button.swatch-element').forEach(b => b.classList.remove('selected'));
              firstEnabled.btn.classList.add('selected');
            }
          }
        });
      });
    }

    function applySharedAuxInventoryGating(baseVariantId) {
      const container = bundleBuilder.querySelector('.bundle-shared-qty');
      if (!container) return;
      const buttons = Array.from(container.querySelectorAll('.bundle-component__qty-btn'));
      if (!buttons.length) return;

      const activeAux = getActiveAuxComponentsForBase(baseVariantId);
      if (!activeAux.length) return;

      const isMixed = activeAux.length > 1;
        const checks = activeAux.map(({ idx }) => {
        const variantId = getVariantIdForComponent(idx);
          if (!variantId) return Promise.resolve({ idx, available: null, quantity: null });
          return fetchVariantAvailability(variantId).then(({ available, quantity }) => ({ idx, available, quantity }));
      });

      Promise.all(checks).then(results => {
          const availabilityMap = new Map(results.map(r => [r.idx, { available: r.available, quantity: r.quantity }]));
        buttons.forEach(btn => {
          const sharedValue = parseInt(btn.dataset.sharedValue, 10);
          if (Number.isNaN(sharedValue)) return;

          if (sharedValue === 0) {
            setButtonDisabled(btn, false, '');
            return;
          }

          const perComponentQty = (() => {
            if (!isMixed) return sharedValue;
            if (sharedValue === 2) return 1;
            return 2;
          })();

          let shouldDisable = false;
          activeAux.forEach(({ idx, comp }) => {
            const data = availabilityMap.get(idx);
            if (!data) return;
            const { available, quantity } = data;
            if (available === null && quantity === null) return;
            const isOut = available === false;
            const canCheckQty = typeof quantity === 'number';
            if (isOut || (canCheckQty && perComponentQty > quantity)) {
              shouldDisable = true;
            }
          });

          setButtonDisabled(
            btn,
            shouldDisable,
            `shared aux qty ${sharedValue} (per component ${perComponentQty})`
          );
        });

        const selectedBtn = container.querySelector('.bundle-component__qty-btn.selected');
        if (selectedBtn && selectedBtn.disabled) {
          const enabledButtons = buttons
            .filter(b => !b.disabled)
            .sort((a, b) => parseInt(b.dataset.sharedValue, 10) - parseInt(a.dataset.sharedValue, 10));
          if (enabledButtons.length) {
            const fallbackValue = parseInt(enabledButtons[0].dataset.sharedValue, 10);
            applySharedAuxSelection(fallbackValue, baseVariantId);
          }
        }
      });
    }

    function applyInventoryGatingAll(baseVariantId) {
      bundleConfig.components.forEach((component, idx) => {
        if (!component.is_base) {
          applyInventoryGatingForComponent(idx);
        }
      });
      applySharedAuxInventoryGating(baseVariantId);
      applyInventoryGatingForChoiceGroups();
    }

    function updateSharedAuxButtonsState(sharedValue) {
      const container = bundleBuilder.querySelector('.bundle-shared-qty');
      if (!container) return;
      container.querySelectorAll('.bundle-component__qty-btn').forEach(btn => {
        btn.classList.toggle('selected', parseInt(btn.dataset.sharedValue, 10) === sharedValue);
      });
    }

    function applySharedAuxSelection(sharedValue, baseVariantId) {
      const normalizedSharedValue = parseInt(sharedValue, 10);
      const safeSharedValue = Number.isNaN(normalizedSharedValue) ? 0 : normalizedSharedValue;
      sharedAuxSelectedValue = safeSharedValue;
      updateSharedAuxButtonsState(safeSharedValue);

      const resolvedBaseVariantId = resolveBaseVariantId(baseVariantId);
      const activeAux = getActiveAuxComponentsForBase(baseVariantId);
      if (!activeAux.length) return;

      // Mixed base (both Aux Pox active) should split: 2 -> 1+1, 4 -> 2+2
      const isMixed = activeAux.length > 1;
      const desiredPerComponent = (() => {
        if (!isMixed) return safeSharedValue;
        if (safeSharedValue === 0) return 0;
        if (safeSharedValue === 2) return 1;
        return 2; // shared 4 -> 2 each
      })();

      if (isDebugEnabled()) {
        debugLog('Shared Aux apply', {
          sharedValue: safeSharedValue,
          baseVariantId,
          resolvedBaseVariantId,
          isMixed,
          activeAux: activeAux.map(({ comp, idx }) => ({
            idx,
            handle: comp.component_product_handle,
            role: comp.shared_qty_role,
            allowed_quantities: comp.allowed_quantities
          }))
        });
      }

      activeAux.forEach(({ comp, idx }) => {
        const targetQty = coerceQuantity(comp, desiredPerComponent);
        selectedQuantities[idx] = targetQty;
        if (isDebugEnabled()) {
          debugLog(`Shared Aux target qty -> component ${idx}`, {
            handle: comp.component_product_handle,
            desiredPerComponent,
            targetQty,
            selectedQuantities: selectedQuantities[idx]
          });
        }

        const compEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
        if (compEl) {
          compEl.querySelectorAll('.bundle-component__qty-btn').forEach(b => {
            b.classList.remove('selected');
            if (parseInt(b.dataset.quantity, 10) === targetQty) {
              b.classList.add('selected');
            }
          });
          const qtyDisplay = compEl.querySelector('.bundle-component__qty-value');
          if (qtyDisplay) {
            qtyDisplay.textContent = targetQty;
          }
        }

        updateComponentPriceDisplay(idx);
        updateComponentDiscountDisplay(idx);
      });

      // Keep components not in activeAux at 0
      sharedQtyComponents
        .filter(({ idx }) => !activeAux.some(a => a.idx === idx))
        .forEach(({ idx }) => {
          selectedQuantities[idx] = 0;
          const compEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
          if (compEl) {
            compEl.querySelectorAll('.bundle-component__qty-btn').forEach(b => b.classList.remove('selected'));
            const zeroBtn = compEl.querySelector('.bundle-component__qty-btn[data-quantity="0"]');
            if (zeroBtn) zeroBtn.classList.add('selected');
            const qtyDisplay = compEl.querySelector('.bundle-component__qty-value');
            if (qtyDisplay) {
              qtyDisplay.textContent = 0;
            }
          }
          updateComponentPriceDisplay(idx);
          updateComponentDiscountDisplay(idx);
        });

      checkBundleReady();
      updateTotalBundlePrice();
      setTimeout(() => {
        scheduleNavigateToOptionalComponentImage();
        if (typeof logFlickityState === 'function') {
          logFlickityState('sharedAuxSelection');
        }
      }, 100);
    }

    function ensureSharedAuxUI(baseVariantId) {
      if (!sharedQtyComponents.length) return;

      let container = bundleBuilder.querySelector('.bundle-shared-qty');
      if (!container) {
        container = document.createElement('div');
        container.className = 'bundle-shared-qty';
        container.dataset.sharedQtyGroup = 'aux-pox';
        const otherComponents = bundleBuilder.querySelector('.bundle-builder__other-components');
        if (otherComponents && otherComponents.parentNode) {
          otherComponents.parentNode.insertBefore(container, otherComponents);
        } else {
          bundleBuilder.appendChild(container);
        }
      }

      container.style.display = 'block';
      container.innerHTML = `
        <div class="swatch is-flex is-flex-wrap bundle-shared-qty__wrap">
          <div class="bundle-shared-qty__label option_title">Aux Pox</div>
          <div class="bundle-shared-qty__buttons"></div>
        </div>
      `;

      const buttonsWrap = container.querySelector('.bundle-shared-qty__buttons');
      buttonsWrap.innerHTML = '';
      sharedAuxDisplayOptions.forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'swatch-element bundle-component__qty-btn';
        btn.dataset.sharedValue = opt.value;
        btn.innerHTML = `<label>${opt.label}</label>`;
        if (opt.value === sharedAuxSelectedValue) {
          btn.classList.add('selected');
        }
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const baseComponent = bundleConfig.components.find(c => c.is_base);
          const currentBaseVariantId = baseComponent ? (selectedVariants[baseComponent.index] || baseComponent.variants[0]?.id) : null;
          applySharedAuxSelection(opt.value, currentBaseVariantId);
        });
        buttonsWrap.appendChild(btn);
      });

      updateSharedAuxButtonsState(sharedAuxSelectedValue);
      const baseComp = bundleConfig.components.find(c => c.is_base);
      const fallbackVariantId = baseComp && baseComp.variants && baseComp.variants.length ? baseComp.variants[0].id : null;
      const currentBaseVariantId = baseVariantId || fallbackVariantId;
      applySharedAuxSelection(sharedAuxSelectedValue, currentBaseVariantId);
      applySharedAuxInventoryGating(currentBaseVariantId);
    }

    function handleSharedAuxOnBaseChange(baseVariantId) {
      if (!sharedQtyComponents.length) return;
      ensureSharedAuxUI(baseVariantId);
    }


  // Perf markers for gallery readiness
  let galleryReadyMarked = false;
  function markGalleryInit() {
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark('bb:init');
    }
  }
  function markGalleryReady() {
    if (galleryReadyMarked) return;
    galleryReadyMarked = true;
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark('bb:gallery-ready');
      if (performance.measure) {
        try {
          performance.measure('gallery-ready', 'bb:init', 'bb:gallery-ready');
        } catch (e) {
          // ignore measure errors
        }
      }
    }
  }

    // Choice-group rebuild guard (initialized early to avoid TDZ when invoked during init)
    let choiceGroupsBuilt = false;
    function rebuildChoiceGroups({ force = false } = {}) {
      if (!force && choiceGroupsBuilt) return;
      teardownChoiceGroupUIs();
      buildChoiceGroupUIs();
      choiceGroupsBuilt = true;
    }

    // Debounced navigation helpers for optional component images (initialized early to avoid TDZ)
    let navigateDebounceTimer = null;
    let lastNavigationSignature = null;
    let navigationRunId = 0;
    function scheduleNavigateToOptionalComponentImage() {
      if (navigateDebounceTimer) {
        clearTimeout(navigateDebounceTimer);
      }
      navigateDebounceTimer = setTimeout(() => {
        navigateDebounceTimer = null;
        navigateToOptionalComponentImage();
      }, 60);
    }
    
    // Wait for jQuery to be available
    if (typeof jQuery === 'undefined') {
      setTimeout(initBundleBuilder, 100);
      debugGroupEnd();
      return;
    }
    const $ = jQuery;
    
    // Handle swatch clicks for bundle components
    function setupSwatchHandlers() {
      bundleBuilder.querySelectorAll('.swatch-element').forEach(swatchEl => {
        swatchEl.addEventListener('click', function(e) {
          e.preventDefault();
          const variantId = parseInt(this.dataset.id);
          const optionIndex = parseInt(this.closest('.swatch').dataset.optionIndex);
          const componentEl = this.closest('.bundle-component');
          
          if (!componentEl) return;
          
          const componentIndex = parseInt(componentEl.dataset.componentIndex);
          const component = bundleConfig.components[componentIndex];
          
          // Update hidden select
          const hiddenSelect = componentEl.querySelector(`#variant-select-${componentIndex}`);
          if (hiddenSelect) {
            // Find variant that matches selected options
            const selectedOptions = {};
            componentEl.querySelectorAll('.swatch-element input:checked').forEach(input => {
              const optIdx = parseInt(input.closest('.swatch').dataset.optionIndex);
              selectedOptions[optIdx] = input.value;
            });
            
            // Set the option value
            const optionInput = this.querySelector('input[type="radio"]');
            if (optionInput) {
              optionInput.checked = true;
            }
            
            // Find matching variant
            const matchingVariant = findVariantByOptions(componentIndex, selectedOptions);
            if (matchingVariant && hiddenSelect) {
              hiddenSelect.value = matchingVariant.id;
              selectedVariants[componentIndex] = matchingVariant.id;
              
              // Trigger change event
              hiddenSelect.dispatchEvent(new Event('change'));
              
              // If this is the base component, switch images
              if (component.is_base && matchingVariant.featured_media) {
                switchProductImage(matchingVariant.featured_media.id);
              }
            }
          }
        });
      });
    }
    
    // Handle quantity button clicks
    function setupQuantityHandlers() {
      bundleBuilder.querySelectorAll('.bundle-component__qty-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const componentIndex = parseInt(this.dataset.componentIndex);
          const quantity = parseInt(this.dataset.quantity);
          const component = bundleConfig.components[componentIndex];
          
          // Update selected quantity
          selectedQuantities[componentIndex] = quantity;
          
          // Update button states
          const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
          if (componentEl) {
            componentEl.querySelectorAll('.bundle-component__qty-btn').forEach(b => {
              b.classList.remove('selected');
            });
            this.classList.add('selected');
            
            // Update quantity display
            const qtyDisplay = componentEl.querySelector('.bundle-component__qty-value');
            if (qtyDisplay) {
              qtyDisplay.textContent = quantity;
            }
          }
          
          // If this is an optional component, navigate to tagged image (even if quantity is 0)
          // When quantity is 0, it will find images without aux pox tags
          if (component.role === 'optional' || component.role === 'accessory') {
            setTimeout(() => {
              scheduleNavigateToOptionalComponentImage();
            }, 100);
          }
          
          // Check if bundle is ready
          checkBundleReady();
          
          // Update price display
          updateComponentPriceDisplay(componentIndex);
          updateComponentDiscountDisplay(componentIndex);
          updateTotalBundlePrice();
        });
      });
      
      // Initialize quantities for components with allowed_quantities
      bundleConfig.components.forEach((component, index) => {
        if (component.allowed_quantities) {
          // Default to 0 (no aux pox) unless explicitly set
          const defaultQty = component.default_qty !== undefined ? component.default_qty : 0;
          selectedQuantities[index] = defaultQty;
          
          // Update UI for quantity buttons on page load
          const componentEl = bundleBuilder.querySelector(`[data-component-index="${index}"]`);
          if (componentEl) {
            const qtyButtons = componentEl.querySelectorAll('.bundle-component__qty-btn');
            qtyButtons.forEach(btn => {
              btn.classList.remove('selected');
              if (parseInt(btn.dataset.quantity) === defaultQty) {
                btn.classList.add('selected');
              }
            });
            
            // Update quantity display
            const qtyDisplay = componentEl.querySelector('.bundle-component__qty-value');
            if (qtyDisplay) {
              qtyDisplay.textContent = defaultQty;
            }
          }
        }
      });
    }
    
    // Find variant by selected options
    function findVariantByOptions(componentIndex, selectedOptions) {
      const component = bundleConfig.components[componentIndex];
      // This would need product data - for now, use the swatch's data-id
      return null; // Will be handled by swatch click handler
    }
    
    // Switch product gallery image based on variant
    function switchProductImage(mediaId) {
      if (!mediaId) return;
      // Ensure Flickity exists before attempting to select
      ensureFlickityInitialized();
      logFlickityState(`switchProductImage mediaId=${mediaId}`);
      
      const $gallery = $('.js-product-gallery');
      if (!$gallery.length) return;
      
      let imageId = null;
      let targetIndex = -1;
      
      if (window.bundleBaseProduct && window.bundleBaseProduct.variants) {
        const variant = window.bundleBaseProduct.variants.find(v => 
          v.featured_media && v.featured_media.id == mediaId
        );
        
        if (variant) {
          imageId = variant.featured_image_id;
          targetIndex = variant.featured_image_index;
        }
      }
      
      // Try to find slide by image ID first
      if (imageId) {
        const $targetSlide = $(`[data-image-id="${imageId}"]`).closest('.gallery-cell');
        if ($targetSlide.length) {
          const flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
          if (flickityInstance) {
            if (selectFlickityCell(flickityInstance, $targetSlide[0], targetIndex, imageId || mediaId)) {
              return;
            }
          }
        }
      }
      
      // Fall back to index-based selection
      if (targetIndex >= 0) {
        const flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
        if (flickityInstance) {
          selectFlickityCell(flickityInstance, null, targetIndex, mediaId || imageId);
        }
      }
    }
    
    // Initialize: set up variant selectors and track selections
    const variantSelectors = bundleBuilder.querySelectorAll('.bundle-variant-select');
    
    variantSelectors.forEach(select => {
      const componentIndex = parseInt(select.dataset.componentIndex);
      const component = bundleConfig.components[componentIndex];
      
      // If component has a fixed variant, set it immediately
      if (component.component_variant_id) {
        selectedVariants[componentIndex] = component.component_variant_id;
      }
      // If it's a hidden input (auto-selected single variant), set it immediately
      else if (select.tagName === 'INPUT' && select.dataset.autoSelected === 'true') {
        selectedVariants[componentIndex] = parseInt(select.value);
      }
      
      // Listen for variant changes (only if it's a select dropdown)
      if (select.tagName === 'SELECT') {
        // Set initial selection - for base component, use first variant; others use first option if available
        if (component.is_base) {
          // Base component: set to first variant and switch gallery image
          const firstOption = Array.from(select.options).find(opt => opt.value && opt.value !== '');
          if (firstOption) {
            const firstVariantId = parseInt(firstOption.value);
            select.value = firstOption.value;
            selectedVariants[componentIndex] = firstVariantId;
            
            // Ensure the corresponding swatch is visually selected
            const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
            if (componentEl) {
              const variantTitle = firstOption.textContent.trim();
              const variantOptionValues = variantTitle.split(' / ');
              
              componentEl.querySelectorAll('.swatch').forEach(swatchGroup => {
                const optionIndex = parseInt(swatchGroup.dataset.optionIndex);
                const expectedValue = variantOptionValues[optionIndex] ? variantOptionValues[optionIndex].trim() : null;
                
                if (expectedValue) {
                  swatchGroup.querySelectorAll('input[type="radio"]').forEach(radio => {
                    radio.checked = false;
                  });
                  
                  swatchGroup.querySelectorAll('.swatch-element').forEach(swatchEl => {
                    if (swatchEl.dataset.value === expectedValue) {
                      const radioInput = swatchEl.previousElementSibling;
                      if (radioInput && radioInput.type === 'radio') {
                        radioInput.checked = true;
                        swatchEl.classList.add('selected');
                      }
                    }
                  });
                }
              });
            }
            
            
            // Apply variant rules for the first variant
            applyVariantRules(componentIndex, firstVariantId, bundleConfig);
          }
        } else {
          // For add-on components (optional/accessory), check if swatches are hidden (only 1 color)
          const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
          if (componentEl && !component.is_base && component.role !== 'required') {
            const swatchesEl = componentEl.querySelector('.bundle-component__swatches');
            // If swatches are hidden (display: none), auto-select first variant
            if (swatchesEl && swatchesEl.style.display === 'none') {
              const firstOption = Array.from(select.options).find(opt => opt.value && opt.value !== '');
              if (firstOption && !select.value) {
                const firstVariantId = parseInt(firstOption.value);
                select.value = firstOption.value;
                selectedVariants[componentIndex] = firstVariantId;
                
                // Trigger change event to update prices and other UI
                select.dispatchEvent(new Event('change'));
              }
            }
          }
          
          // Other components: use existing value if set
          if (select.value) {
            const initialVariantId = parseInt(select.value);
            if (initialVariantId) {
              selectedVariants[componentIndex] = initialVariantId;
              
              // If there's only one variant and swatches are shown, mark it as selected
              if (select.tagName === 'SELECT' && select.options.length === 2) { // 2 = empty option + 1 variant
                const singleVariantOption = Array.from(select.options).find(opt => opt.value && opt.value !== '');
                if (singleVariantOption) {
                  const componentEl = select.closest('.bundle-component');
                  const variantTitle = singleVariantOption.textContent.trim();
                  const variantOptionValues = variantTitle.split(' / ');
                  
                  // Mark the corresponding swatch as selected
                  componentEl.querySelectorAll('.swatch').forEach(swatchGroup => {
                    const optionIndex = parseInt(swatchGroup.dataset.optionIndex);
                    const expectedValue = variantOptionValues[optionIndex] ? variantOptionValues[optionIndex].trim() : null;
                    
                    if (expectedValue) {
                      swatchGroup.querySelectorAll('input[type="radio"]').forEach(radio => {
                        radio.checked = false;
                      });
                      
                      swatchGroup.querySelectorAll('.swatch-element').forEach(swatchEl => {
                        if (swatchEl.dataset.value === expectedValue) {
                          const radioInput = swatchEl.previousElementSibling;
                          if (radioInput && radioInput.type === 'radio') {
                            radioInput.checked = true;
                            swatchEl.classList.add('selected');
                          }
                        }
                      });
                    }
                  });
                }
              }
            }
          }
        }
        
        select.addEventListener('change', function() {
          // Only apply variant rules if this is the configured base component
          // Rules are triggered by base component variants, not dependent component variants
          if (componentIndex !== baseComponentIndex) {
            debugLog(`Skipping applyVariantRules for component ${componentIndex} (not base component) - change event`);
            return;
          }
          const variantId = parseInt(this.value);
          if (!variantId) return;
          
          selectedVariants[componentIndex] = variantId;
          
          // If this is an optional/required component, navigate to tagged image
          if (component.role === 'optional' || component.role === 'accessory' || component.role === 'required') {
            setTimeout(() => {
              scheduleNavigateToOptionalComponentImage();
            }, 100);
          }
          
          // Apply variant dependency rules (only for base component)
          // Rules are triggered by base component variants, not dependent component variants
          if (componentIndex === baseComponentIndex) {
            applyVariantRules(componentIndex, variantId, bundleConfig);
            handleSharedAuxOnBaseChange(variantId);
            
            // For base component, navigate to best matching image after variant rules are applied
            // This ensures dependent components are auto-selected first
            setTimeout(() => {
              scheduleNavigateToOptionalComponentImage();
            }, 150);
          }
          
          // Check if bundle is ready to add to cart
          checkBundleReady();
          
          // Update price display
          updateComponentPriceDisplay(componentIndex);
          updateComponentDiscountDisplay(componentIndex);
          updateTotalBundlePrice();
          applyInventoryGatingForComponent(componentIndex);
          applyInventoryGatingForChoiceGroups();
          const baseComp = bundleConfig.components.find(c => c.is_base);
          const baseVariantId = baseComp ? selectedVariants[baseComp.index] : null;
          applySharedAuxInventoryGating(baseVariantId);
        });
      }
    });
    
    // Setup swatch handlers
    setupSwatchHandlers();
    setupQuantityHandlers();
    
    // Apply initial variant rules if base component has a selected variant
    const baseComponent = bundleConfig.components.find(c => c.is_base);
    if (baseComponent && selectedVariants[baseComponent.index]) {
      applyVariantRules(baseComponent.index, selectedVariants[baseComponent.index], bundleConfig);
      handleSharedAuxOnBaseChange(selectedVariants[baseComponent.index]);
    } else if (baseComponent && baseComponent.variants && baseComponent.variants.length) {
      handleSharedAuxOnBaseChange(baseComponent.variants[0].id);
    }
    if (baseComponent) {
      const baseVariantId = selectedVariants[baseComponent.index] || (baseComponent.variants && baseComponent.variants.length ? baseComponent.variants[0].id : null);
      applyInventoryGatingAll(baseVariantId);
    }
    
    // After initializing all selectors, check if bundle is ready (for auto-selected variants)
    checkBundleReady();
    
    // Update price displays on initial load
    updateBundlePriceDisplay();
    // Update discount displays on initial load
    bundleConfig.components.forEach((component, index) => {
      updateComponentDiscountDisplay(index);
    });
    // Check and hide swatches for add-on components with only 1 visible color (after initial load)
    setTimeout(() => {
      checkAndHideSingleColorSwatches();
    }, 300);
    // Wait a bit for price element to be ready, then update total bundle price and choice UI (only once unless forced)
    setTimeout(() => {
      updateTotalBundlePrice();
      rebuildChoiceGroups({ force: false });
      ensureFlickityInitialized(true);
    }, 100);

    // Navigate to best matching image on initial load (component-tagged or featured image)
    // This function handles both cases: uses featured image if only base component,
    // or finds component-tagged image if optional components are selected
    setTimeout(() => {
      scheduleNavigateToOptionalComponentImage();
    }, 1500); // Wait for gallery to be fully initialized

    /**
     * Apply variant dependency rules
     * When a trigger variant is selected, filter allowed variants for dependent components
     */
    function applyVariantRules(componentIndex, selectedVariantId, config) {
      debugGroup(`🔧 applyVariantRules: componentIndex=${componentIndex}, selectedVariantId=${selectedVariantId}`);
      
      // Debug: Show all available rules with full details
      debugLog('=== ALL VARIANT RULES ===');
      config.variant_rules.forEach((rule, idx) => {
        debugLog(`Rule ${idx}:`, {
          trigger_variant_id: rule.trigger_variant_id,
          allowed_variant_ids: rule.allowed_variant_ids,
          allowed_variant_ids_count: rule.allowed_variant_ids ? rule.allowed_variant_ids.length : 0
        });
      });
      debugLog('Looking for variant ID:', selectedVariantId);
      debugLog('Rule trigger variant IDs:', config.variant_rules.map(r => r.trigger_variant_id));
      debugLog('=== END VARIANT RULES ===');
      
      // Get the selected variant from the base component to extract its option values
      const baseComponent = config.components[componentIndex];
      const selectedVariant = baseComponent.variants.find(v => v.id === selectedVariantId);
      
      if (!selectedVariant) {
        debugWarn(`⚠️ Selected variant ${selectedVariantId} not found in base component`);
        resetVariantFilters(config.components
          .map((comp, idx) => ({ comp, idx }))
          .filter(({ comp, idx }) => idx !== componentIndex && comp.component_variant_id === null));
        debugGroupEnd();
        return;
      }
      
      // Prefer exact variant match so size-specific rules apply
      let matchingRules = config.variant_rules.filter(rule => rule.trigger_variant_id === selectedVariantId);

      // Fallback to legacy color-based match only if no exact rule exists
      if (matchingRules.length === 0) {
        // Extract the first option value (Color) from variant title (e.g., "Black" from "Black / 25L + 25L")
        const variantTitle = selectedVariant.title;
        const optionValues = variantTitle.split(' / ');
        const firstOptionValue = optionValues[0] ? optionValues[0].trim() : null;
        
        debugLog(`No exact rule found; fallback by color. Selected variant: ${variantTitle}, First option value (Color): ${firstOptionValue}`);
        
        if (!firstOptionValue) {
          debugWarn(`⚠️ Could not extract first option value from variant title: ${variantTitle}`);
          resetVariantFilters(config.components
            .map((comp, idx) => ({ comp, idx }))
            .filter(({ comp, idx }) => idx !== componentIndex && comp.component_variant_id === null));
          debugGroupEnd();
          return;
        }
        
        // Find all variants of the base product that share the same first option value (Color)
        const matchingBaseVariantIds = baseComponent.variants
          .filter(v => {
            const vOptionValues = v.title.split(' / ');
            const vFirstOptionValue = vOptionValues[0] ? vOptionValues[0].trim() : null;
            return vFirstOptionValue === firstOptionValue;
          })
          .map(v => v.id);
        
        debugLog(`Base variants with same color (${firstOptionValue}):`, matchingBaseVariantIds);
        
        // Find ALL rules where trigger_variant_id matches any of the variants with the same color
        matchingRules = config.variant_rules.filter(rule => 
          matchingBaseVariantIds.includes(rule.trigger_variant_id)
        );

        debugLog(`Found ${matchingRules.length} matching rule(s) for color "${firstOptionValue}":`, matchingRules.map((rule, idx) => ({
          index: idx,
          trigger_variant_id: rule.trigger_variant_id,
          allowed_variant_ids: rule.allowed_variant_ids
        })));
        
        if (matchingRules.length === 0) {
          debugWarn(`⚠️ No rules found for color "${firstOptionValue}" (variant IDs: ${matchingBaseVariantIds.join(', ')})`);
          debugLog('Available trigger variant IDs:', config.variant_rules.map(r => r.trigger_variant_id));
        }
      } else {
        debugLog(`Found ${matchingRules.length} exact matching rule(s) for variant ID ${selectedVariantId}`);
      }

    // Apply quantity overrides that depend on the selected base variant
    applyQuantityOverrides(selectedVariantId);
    handleSharedAuxOnBaseChange(selectedVariantId);

      // Combine all allowed variant IDs from all matching rules
      const allAllowedVariantIds = matchingRules.reduce((acc, rule) => {
        return acc.concat(rule.allowed_variant_ids);
      }, []);

      debugLog('Combined allowed_variant_ids from all rules:', allAllowedVariantIds);

      // Find all dependent components (components without fixed variants)
      const dependentComponents = config.components
        .map((comp, idx) => ({ comp, idx }))
        .filter(({ comp, idx }) => 
          idx !== componentIndex && 
          comp.component_variant_id === null
        );

      debugLog('Dependent components:', dependentComponents.map(({ idx }) => idx));

      // If no matching rules, reset all filters to show all options
      if (matchingRules.length === 0) {
        debugLog('No matching rules, resetting filters');
        resetVariantFilters(dependentComponents);
        debugGroupEnd();
        return;
      }
      
      // Create a combined rule object for compatibility with existing code
      const combinedRule = {
        trigger_variant_id: selectedVariantId,
        allowed_variant_ids: allAllowedVariantIds
      };

      // Apply the rule to dependent components
      dependentComponents.forEach(({ idx }) => {
        const componentEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
        if (!componentEl) return;
        
        const dependentSelect = componentEl.querySelector(`#variant-select-${idx}`);
        if (!dependentSelect) return;
        
        // Skip if it's a hidden input (auto-selected single variant)
        if (dependentSelect.tagName === 'INPUT') return;
        
        // Get component product data to understand variant structure
        const component = config.components[idx];
        const componentProductId = component.component_product_id;
        
        // Get all options in hidden select
        const allOptions = Array.from(dependentSelect.options);
        
        // Get all swatch elements for this component
        const swatchElements = componentEl.querySelectorAll('.swatch-element');
        const swatchGroups = componentEl.querySelectorAll('.swatch');
        
        // Build a map of which option values are valid for each option index
        const validOptionValues = {}; // { optionIndex: Set of valid values }
        
        // First, filter the hidden select options
        // Only check variant IDs that actually exist in this component's select options
        const componentVariantIds = allOptions
          .filter(opt => opt.value !== '')
          .map(opt => parseInt(opt.value));
        
        // Filter allowed_variant_ids to only include variants that belong to this component
        const allowedVariantIdsForThisComponent = combinedRule.allowed_variant_ids.filter(vid => 
          componentVariantIds.includes(vid)
        );
        
        debugLog(`Component ${idx}: componentVariantIds=[${componentVariantIds.join(', ')}], allowedVariantIdsForThisComponent=[${allowedVariantIdsForThisComponent.join(', ')}]`);
        
        allOptions.forEach(option => {
          if (option.value === '') return; // Keep "Choose an option..."
          
          const optionVariantId = parseInt(option.value);
          const isAllowed = allowedVariantIdsForThisComponent.includes(optionVariantId);
          
          debugLog(`  Option variant ${optionVariantId} (${option.textContent.trim()}): isAllowed=${isAllowed}`);
          
          if (!isAllowed) {
            option.style.display = 'none';
            option.disabled = true;
            
            // If this was the selected option, clear selection
            if (dependentSelect.value === option.value) {
              dependentSelect.value = '';
              delete selectedVariants[idx];
            }
          } else {
            option.style.display = '';
            option.disabled = option.dataset.variantAvailable === 'false';
            
            // Parse variant title to extract option values (e.g., "Grey / 8L" -> ["Grey", "8L"])
            const variantTitle = option.textContent.trim();
            const optionValues = variantTitle.split(' / ');
            
            // Track which option values are valid
            optionValues.forEach((value, optIdx) => {
              if (!validOptionValues[optIdx]) {
                validOptionValues[optIdx] = new Set();
              }
              const trimmedValue = value.trim();
              validOptionValues[optIdx].add(trimmedValue);
              debugLog(`  Allowed variant "${variantTitle}" -> option[${optIdx}]="${trimmedValue}"`);
            });
          }
        });
        
        // Now filter swatches based on valid option values
        debugLog(`Filtering swatches for component ${idx}, validOptionValues:`, 
          Object.keys(validOptionValues).reduce((acc, key) => {
            acc[key] = Array.from(validOptionValues[key]);
            return acc;
          }, {})
        );
        
        // If no variants are allowed for this component, hide all swatches
        const hasAllowedVariants = allowedVariantIdsForThisComponent.length > 0;

        // Hide the entire component (title/discount/swatches/qty) if no allowed variants
        componentEl.style.display = hasAllowedVariants ? '' : 'none';
        // When hidden, clear selected variant and default quantity to 0 to avoid validation errors
        if (!hasAllowedVariants) {
          delete selectedVariants[idx];
          selectedQuantities[idx] = 0;
        }
        
        swatchGroups.forEach(swatchGroup => {
          const optionIndex = parseInt(swatchGroup.dataset.optionIndex);
          const validValues = validOptionValues[optionIndex] || new Set();
          
          swatchGroup.querySelectorAll('.swatch-element').forEach(swatchEl => {
            const swatchValue = swatchEl.dataset.value;
            const isValueValid = validValues.has(swatchValue);
            
            debugLog(`  Swatch optionIndex=${optionIndex}, value="${swatchValue}", valid=${isValueValid}, validValues=[${Array.from(validValues).join(', ')}], hasAllowedVariants=${hasAllowedVariants}`);
            
            // Hide swatch if:
            // 1. No variants are allowed for this component at all, OR
            // 2. This specific value is not valid (and we have some valid values)
            if (!hasAllowedVariants || (!isValueValid && validValues.size > 0)) {
              // Hide swatch if its value is not in the valid set
              swatchEl.style.display = 'none';
              // Uncheck radio input if checked (input is previous sibling of swatch-element)
              const radioInput = swatchEl.previousElementSibling;
              if (radioInput && radioInput.type === 'radio' && radioInput.checked) {
                radioInput.checked = false;
                swatchEl.classList.remove('selected');
                // If this was the last checked option, we need to clear the selection
                const hasCheckedOption = Array.from(swatchGroup.querySelectorAll('input[type="radio"]')).some(radio => radio.checked);
                if (!hasCheckedOption && dependentSelect.value) {
                  // Clear the dependent select if no option is checked
                  dependentSelect.value = '';
                  delete selectedVariants[idx];
                }
              }
            } else {
              // Show swatch if its value is valid
              swatchEl.style.display = '';
            }
          });
        });

        // Hide the Color swatch group entirely when only one visible swatch remains
        const firstSwatchGroup = componentEl.querySelector('.bundle-component__swatches .swatch[data-option-index="0"]');
        if (firstSwatchGroup) {
          const visibleColorSwatches = Array.from(firstSwatchGroup.querySelectorAll('.swatch-element')).filter(
            swatch => swatch.style.display !== 'none' && swatch.offsetParent !== null
          );
          firstSwatchGroup.style.display = visibleColorSwatches.length <= 1 ? 'none' : '';
        }
        
        debugGroupEnd();

        // Auto-select first allowed variant, but only if:
        // 1. No variant is currently selected, OR
        // 2. The currently selected variant is not in the allowed list
        if (combinedRule.allowed_variant_ids.length > 0) {
          const currentVariantId = selectedVariants[idx];
          const currentVariantIsAllowed = currentVariantId && 
            combinedRule.allowed_variant_ids.includes(currentVariantId);
          
          debugLog(`Component ${idx}: currentVariantId=${currentVariantId}, allowed=${currentVariantIsAllowed}, allowed_variant_ids=${combinedRule.allowed_variant_ids.join(', ')}`);
          
          // Only auto-select if no variant is selected or current selection is not allowed
          if (!currentVariantIsAllowed) {
            debugLog(`  ⚠️ Auto-selecting new variant for component ${idx} (current selection not allowed)`);
          } else {
            debugLog(`  ✅ Preserving current variant selection for component ${idx} (still allowed)`);
          }
          
          if (!currentVariantIsAllowed) {
            const firstAllowed = allOptions.find(opt => 
              opt.value !== '' && 
              combinedRule.allowed_variant_ids.includes(parseInt(opt.value)) &&
              opt.style.display !== 'none'
            );
            if (firstAllowed) {
              dependentSelect.value = firstAllowed.value;
              selectedVariants[idx] = parseInt(firstAllowed.value);
              
              // Parse variant title to get option values (e.g., "Grey / 8L" -> ["Grey", "8L"])
              const variantTitle = firstAllowed.textContent.trim();
              const optionValues = variantTitle.split(' / ');
              
              // Set swatch radio inputs to match the variant's options
              swatchGroups.forEach(swatchGroup => {
                const optionIndex = parseInt(swatchGroup.dataset.optionIndex);
                const expectedValue = optionValues[optionIndex] ? optionValues[optionIndex].trim() : null;
                
                if (expectedValue) {
                  // Uncheck all radios in this option group first
                  swatchGroup.querySelectorAll('input[type="radio"]').forEach(radio => {
                    radio.checked = false;
                    // Remove selected class from sibling swatch-element
                    const siblingSwatch = radio.nextElementSibling;
                    if (siblingSwatch && siblingSwatch.classList.contains('swatch-element')) {
                      siblingSwatch.classList.remove('selected');
                    }
                  });
                  
                  // Find and check the swatch with matching value
                  swatchGroup.querySelectorAll('.swatch-element').forEach(swatchEl => {
                    if (swatchEl.dataset.value === expectedValue && swatchEl.style.display !== 'none') {
                      const radioInput = swatchEl.previousElementSibling;
                      if (radioInput && radioInput.type === 'radio') {
                        radioInput.checked = true;
                        swatchEl.classList.add('selected');
                      } else {
                        // Try finding by value
                        const radioByValue = swatchGroup.querySelector(`input[type="radio"][value="${expectedValue.replace(/"/g, '\\"')}"]`);
                        if (radioByValue) {
                          radioByValue.checked = true;
                          swatchEl.classList.add('selected');
                        }
                      }
                    }
                  });
                }
              });
              
              // Trigger change event to update UI and trigger navigation
              dependentSelect.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Update price display for this component
              updateComponentPriceDisplay(idx);
              updateComponentDiscountDisplay(idx);
            }
          }
        }
        
        // Handle components with allowed_quantities (like aux pox) - default to quantity 0
        const componentWithQty = config.components[idx];
        if (componentWithQty.allowed_quantities) {
          // Set to 0 if not already set, or ensure it's set to 0 when rules are applied
          if (selectedQuantities[idx] === undefined) {
            selectedQuantities[idx] = 0;
          }
          
          // Update UI for quantity buttons
          const qtyButtons = componentEl.querySelectorAll('.bundle-component__qty-btn');
          if (qtyButtons.length > 0) {
            qtyButtons.forEach(btn => {
              btn.classList.remove('selected');
              if (parseInt(btn.dataset.quantity) === selectedQuantities[idx]) {
                btn.classList.add('selected');
              }
            });
            
            // Update quantity display
            const qtyDisplay = componentEl.querySelector('.bundle-component__qty-value');
            if (qtyDisplay) {
              qtyDisplay.textContent = selectedQuantities[idx];
            }
          }
        }
      });
      
      // Check and hide swatches for components (required/optional/accessory) with only 1 visible color
      checkAndHideSingleColorSwatches();
      
      // Update total bundle price after applying variant rules
      updateTotalBundlePrice();
      // Re-validate readiness (clears error if hidden components were causing it)
      checkBundleReady();
      // Rebuild choice group UI to reflect any visibility/quantity rule changes
      rebuildChoiceGroups({ force: true });
      applyInventoryGatingAll(selectedVariantId);
    }

    /**
     * Parse quantity labels string "0:Label 0,1:Label 1" into a map
     */
    function parseQuantityLabels(labelString) {
      if (!labelString) return {};
      return labelString.split(',').reduce((acc, pair) => {
        const parts = pair.split(':');
        if (parts.length === 2) {
          const key = parts[0].trim();
          const val = parts[1].trim();
          acc[key] = val;
        }
        return acc;
      }, {});
    }

    /**
     * Rebuild quantity buttons for a component based on its current allowed_quantities/default_qty/labels
     */
    function rebuildQuantityButtons(component, index) {
      const compEl = bundleBuilder.querySelector(`[data-component-index="${index}"]`);
      if (!compEl) return;

      const qtyWrapper = compEl.querySelector('.bundle-component__quantity-selector');
      const qtyContainer = qtyWrapper ? qtyWrapper.querySelector('.swatch') : null;
      if (!qtyContainer) return;

      // Show/hide wrapper based on allowed_quantities
      if (!component.allowed_quantities) {
        qtyWrapper.style.display = 'none';
        return;
      }
      qtyWrapper.style.display = '';

      // Reset contents
      qtyContainer.innerHTML = '<div class="option_title">Quantity</div>';

      const allowedQtyArray = component.allowed_quantities
        .split(',')
        .map(q => parseInt(q.trim(), 10))
        .filter(q => !isNaN(q));

      const labelMap = parseQuantityLabels(component.quantity_labels);
      let defaultQty = component.default_qty !== undefined && component.default_qty !== null
        ? component.default_qty
        : (component.min_qty || 0);

      if (!allowedQtyArray.includes(defaultQty) && allowedQtyArray.length > 0) {
        defaultQty = allowedQtyArray[0];
      }

      // Update tracked selection
      selectedQuantities[index] = defaultQty;

      // Helper to build label
      const getDisplayLabel = (qty) => {
        if (labelMap.hasOwnProperty(String(qty))) return labelMap[String(qty)];
        if (qty === 0) {
          return 'Without ' + (component.component_product_handle || component.title || 'Item');
        }
        return `${qty} ${(component.component_product_handle || component.title || 'Item')}`;
      };

      allowedQtyArray.forEach(qty => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'swatch-element bundle-component__qty-btn';
        btn.dataset.quantity = qty;
        btn.dataset.componentIndex = index;
        btn.innerHTML = `<label>${getDisplayLabel(qty)}</label>`;
        if (qty === defaultQty) {
          btn.classList.add('selected');
        }

        // Bind click handler (same behavior as original setupQuantityHandlers)
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const componentIndex = parseInt(this.dataset.componentIndex);
          const quantity = parseInt(this.dataset.quantity);
          const comp = bundleConfig.components[componentIndex];

          selectedQuantities[componentIndex] = quantity;

          const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
          if (componentEl) {
            componentEl.querySelectorAll('.bundle-component__qty-btn').forEach(b => {
              b.classList.remove('selected');
            });
            this.classList.add('selected');

            const qtyDisplay = componentEl.querySelector('.bundle-component__qty-value');
            if (qtyDisplay) {
              qtyDisplay.textContent = quantity;
            }
          }

          if (comp.role === 'optional' || comp.role === 'accessory') {
            setTimeout(() => {
              scheduleNavigateToOptionalComponentImage();
            }, 100);
          }

          checkBundleReady();
          updateComponentPriceDisplay(componentIndex);
          updateComponentDiscountDisplay(componentIndex);
          updateTotalBundlePrice();
        });

        qtyContainer.appendChild(btn);
      });
      applyInventoryGatingForComponent(index);
    }

    /**
     * Reset quantity configs to their original values
     */
    function resetQuantityConfigsToOriginal() {
      bundleConfig.components.forEach((component, idx) => {
        if (!originalQuantityConfig[idx]) return;
        component.allowed_quantities = originalQuantityConfig[idx].allowed_quantities;
        component.default_qty = originalQuantityConfig[idx].default_qty;
        component.quantity_labels = originalQuantityConfig[idx].quantity_labels;
        if (component.allowed_quantities) {
          rebuildQuantityButtons(component, idx);
        }
      });
    }

    /**
     * Apply quantity overrides based on base variant rules
     */
    function applyQuantityOverrides(baseVariantId) {
      if (!Array.isArray(bundleConfig.quantity_rules) || bundleConfig.quantity_rules.length === 0) {
        return;
      }

      // Reset to original before applying overrides
      resetQuantityConfigsToOriginal();

      const matchingRules = bundleConfig.quantity_rules.filter(r => r.trigger_variant_id === baseVariantId);
      if (matchingRules.length === 0) return;

      matchingRules.forEach(rule => {
        const compIndex = bundleConfig.components.findIndex(c => c.component_product_handle === rule.component_handle);
        if (compIndex === -1) return;
        const component = bundleConfig.components[compIndex];

        if (rule.allowed_quantities) {
          component.allowed_quantities = rule.allowed_quantities;
        }
        if (rule.default_qty !== undefined && rule.default_qty !== null) {
          component.default_qty = rule.default_qty;
        }
        if (rule.quantity_labels) {
          component.quantity_labels = rule.quantity_labels;
        }

        rebuildQuantityButtons(component, compIndex);
        updateComponentPriceDisplay(compIndex);
        updateComponentDiscountDisplay(compIndex);
      });

      updateTotalBundlePrice();
      checkBundleReady();
    }

    /**
     * Build combined UI for choice groups (components sharing choice_group).
     * Supports pick-one groups (choice_min=1, choice_max=1) with allowed_quantities including 0/1.
     */
    function buildChoiceGroupUIs() {
      const groups = {};

      bundleConfig.components.forEach((component, idx) => {
        if (component.choice_group) {
          if (!groups[component.choice_group]) {
            groups[component.choice_group] = [];
          }
          groups[component.choice_group].push({ component, idx });
        }
      });

      Object.entries(groups).forEach(([groupKey, items]) => {
        if (items.length < 2) return;

        // Ensure group is pick-one style
        const first = items[0].component;
        const isPickOne = (items.every(({ component }) =>
          component.choice_min === 1 &&
          (component.choice_max === 1 || component.choice_max === null || component.choice_max === undefined) &&
          component.allowed_quantities &&
          component.allowed_quantities.split(',').map(q => q.trim()).includes('0') &&
          component.allowed_quantities.split(',').map(q => q.trim()).includes('1')
        ));
        if (!isPickOne) return;

        // Insert combined UI before the first component element
        const firstEl = bundleBuilder.querySelector(`[data-component-index="${items[0].idx}"]`);
        if (!firstEl) return;

        const container = document.createElement('div');
        container.className = 'bundle-choice-group';
        container.dataset.choiceGroup = groupKey;
        container.innerHTML = `
          <div class="bundle-component__title"><h4>Stinger Choice</h4></div>
          <div class="bundle-choice-group__options swatch is-flex is-flex-wrap"></div>
        `;

        const optionsEl = container.querySelector('.bundle-choice-group__options');

        items.forEach(({ component, idx }) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'swatch-element bundle-component__qty-btn';
          btn.dataset.choiceIdx = idx;
          btn.innerHTML = `<label>${component.component_product_handle || component.title || 'Option'}</label>`;
          optionsEl.appendChild(btn);
        });

        firstEl.parentNode.insertBefore(container, firstEl);

        // Hide original component UIs for this group
        items.forEach(({ idx }) => {
          const compEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
          if (compEl) {
            compEl.dataset.choiceHidden = 'true';
            compEl.style.display = 'none';
          }
        });

        // Set initial selection: first allowed
        const firstAllowed = items[0].idx;
        setChoiceSelection(groupKey, firstAllowed, items);

        // Wire buttons
        container.querySelectorAll('button.swatch-element').forEach(btn => {
          btn.addEventListener('click', () => {
            if (btn.disabled) return;
            const selectedIdx = parseInt(btn.dataset.choiceIdx, 10);
            setChoiceSelection(groupKey, selectedIdx, items);
            // Update selected state visuals
            container.querySelectorAll('button.swatch-element').forEach(b => b.classList.remove('selected'));
            btn.classList.add('selected');
          });
        });

        // Mark the first as selected visually
        const firstBtn = container.querySelector('button.swatch-element');
        if (firstBtn) firstBtn.classList.add('selected');

        // Apply inventory gating to choice group options
        applyInventoryGatingForChoiceGroups();
      });
    }

    function setChoiceSelection(groupKey, selectedIdx, items) {
      items.forEach(({ idx }) => {
        const qty = idx === selectedIdx ? 1 : 0;
        selectedQuantities[idx] = qty;

        const compEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
        if (compEl) {
          compEl.querySelectorAll('.bundle-component__qty-btn').forEach(btn => {
            btn.classList.remove('selected');
            if (parseInt(btn.dataset.quantity, 10) === qty) {
              btn.classList.add('selected');
            }
          });
          const qtyDisplay = compEl.querySelector('.bundle-component__qty-value');
          if (qtyDisplay) qtyDisplay.textContent = qty;
        }
      });

      checkBundleReady();
      updateTotalBundlePrice();
      updateBundlePriceDisplay();
      logFlickityState(`setChoiceSelection group=${groupKey} selected=${selectedIdx}`);
      // Trigger gallery/logging updates for choice groups so variant-tagged images stay in sync
      setTimeout(() => scheduleNavigateToOptionalComponentImage(), 100);
    }

    function teardownChoiceGroupUIs() {
      // Remove combined blocks
      document.querySelectorAll('.bundle-choice-group').forEach(el => el.remove());
      // Unhide components that were hidden solely for choice grouping
      bundleConfig.components.forEach((component, idx) => {
        const compEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
        if (compEl && compEl.dataset.choiceHidden === 'true') {
          compEl.style.display = '';
          delete compEl.dataset.choiceHidden;
        }
      });
    }


    function ensureFlickityInitialized(isInitialAttempt = false, retryCount = 0) {
      const $ = window.jQuery;
      if (!$) return;

      const $gallery = $('.js-product-gallery');
      if (!$gallery.length) return;

      const existing = window.Flickity && window.Flickity.data($gallery[0]);
      if (existing) {
        markGalleryReady();
        if (isDebugEnabled()) {
          infoLog(`📸 ensureFlickityInitialized: already initialized (initial=${isInitialAttempt}, retry=${retryCount})`);
        }
        return;
      }

      try {
        if (window.productPage && typeof window.productPage.enableGallery === 'function') {
          window.productPage.enableGallery($gallery);
        } else if (window.Flickity) {
          const galleryData = $gallery.data();
          $gallery.flickity({
            cellSelector: '.gallery-cell',
            imagesLoaded: true,
            lazyLoad: 2,
            draggable: true,
            prevNextButtons: galleryData.galleryArrowsEnabled !== 'false',
            pageDots: false,
            wrapAround: true,
            adaptiveHeight: false
          });
          markGalleryReady();
        }
        logFlickityState('ensureFlickityInitialized:afterInit');
      } catch (err) {
        errorLog('ensureFlickityInitialized failed', err);
      }
    }

    function startFlickityInitLoop() {
      ensureFlickityInitialized(true, 0);
    }

    function logFlickityState(label) {
      if (!isDebugEnabled()) return;
      const $ = window.jQuery;
      const $gallery = $ && $('.js-product-gallery');
      const $cells = $gallery ? $gallery.find('.gallery-cell') : null;
      const hasInstance = window.Flickity && $gallery && $gallery.length && window.Flickity.data($gallery[0]);
      infoLog(`📸 Flickity State [${label}]`, {
        galleryExists: !!($gallery && $gallery.length),
        cellCount: $cells ? $cells.length : 0,
        hasInstance: !!hasInstance
      });
    }

    /**
     * Check if components (required/optional/accessory) have only 1 visible color swatch and hide swatches container
     */
    function checkAndHideSingleColorSwatches() {
      bundleConfig.components.forEach((component, index) => {
        // Only exclude base components - check required and add-on components
        if (component.is_base) {
          return;
        }

        const componentEl = bundleBuilder.querySelector(`[data-component-index="${index}"]`);
        if (!componentEl) return;

        const swatchesEl = componentEl.querySelector('.bundle-component__swatches');
        if (!swatchesEl) return;

        // Find the first swatch group (Color option)
        const firstSwatchGroup = swatchesEl.querySelector('.swatch[data-option-index="0"]');
        if (!firstSwatchGroup) return;

        // Count visible color swatch elements (not hidden by variant rules)
        const visibleSwatches = Array.from(firstSwatchGroup.querySelectorAll('.swatch-element')).filter(
          swatch => swatch.offsetParent !== null && swatch.style.display !== 'none'
        );

        // If 0 or 1 visible color, hide the Color swatch group (not the entire container)
        if (visibleSwatches.length <= 1) {
          firstSwatchGroup.style.display = 'none';
          
          // Auto-select the visible variant if not already selected
          const visibleSwatch = visibleSwatches[0];
          if (visibleSwatch) {
            const variantId = parseInt(visibleSwatch.dataset.id);
            if (variantId) {
              const hiddenSelect = componentEl.querySelector(`#variant-select-${index}`);
              if (hiddenSelect && hiddenSelect.tagName === 'SELECT') {
                // Find the variant that matches the visible color (may need to check size too)
                // For now, just select the first matching variant with this color
                const matchingOption = Array.from(hiddenSelect.options).find(opt => {
                  if (!opt.value) return false;
                  const optVariantId = parseInt(opt.value);
                  return optVariantId === variantId;
                });
                
                if (matchingOption && hiddenSelect.value !== matchingOption.value) {
                  hiddenSelect.value = matchingOption.value;
                  selectedVariants[index] = parseInt(matchingOption.value);
                  hiddenSelect.dispatchEvent(new Event('change'));
                }
              }
            }
          }
        } else {
          // Show Color swatch group if more than 1 color is visible
          firstSwatchGroup.style.display = '';
        }
      });
    }

    /**
     * Reset variant filters - show all options when no rule applies
     */
    function resetVariantFilters(dependentComponents) {
      dependentComponents.forEach(({ idx }) => {
        const componentEl = bundleBuilder.querySelector(`[data-component-index="${idx}"]`);
        if (!componentEl) return;
        
        const dependentSelect = componentEl.querySelector(`#variant-select-${idx}`);
        
        if (!dependentSelect || dependentSelect.tagName === 'INPUT') return;

        // Show all options in hidden select
        const allOptions = Array.from(dependentSelect.options);
        allOptions.forEach(option => {
          if (option.value === '') return; // Keep "Choose an option..."
          option.style.display = '';
          option.disabled = false;
        });
        
        // Show all swatch elements
        const swatchElements = componentEl.querySelectorAll('.swatch-element');
        swatchElements.forEach(swatchEl => {
          swatchEl.style.display = '';
        });
      });
      
      // Check and hide swatches for components (required/optional/accessory) with only 1 visible color
      checkAndHideSingleColorSwatches();
    }

    /**
     * Show or hide the Notify Me form based on whether the selected base variant is OOS.
     * Mirrors the logic in sections.js.liquid for standard product pages.
     */
    function updateBundleNotifyMe(baseVariantId) {
      const notifyForm = bundleBuilder.parentElement
        ? bundleBuilder.parentElement.querySelector('[class*="notify-form-"]')
        : document.querySelector('[class*="notify-form-"]');
      if (!notifyForm) return;

      const notifyFormInputs = notifyForm.querySelector('.notify_form__inputs');
      if (!notifyFormInputs) return;

      if (!baseVariantId) {
        notifyForm.style.display = 'none';
        notifyFormInputs.innerHTML = '';
        return;
      }

      const availInfo = getAvailabilityFromConfig(baseVariantId);
      const isOOS = availInfo && availInfo.available === false;

      if (isOOS) {
        const baseCompConfig = bundleConfig.components.find(c => c.is_base);
        const variantData = baseCompConfig && baseCompConfig.variants
          ? baseCompConfig.variants.find(v => v.id === baseVariantId)
          : null;
        const variantTitle = variantData ? variantData.title : '';

        const productTitle = notifyForm.dataset.productTitle || '';
        const notifyUrl = notifyFormInputs.dataset.url || window.location.href;
        const t = window.PXUTheme && window.PXUTheme.translation;
        const customerEmail = notifyForm.dataset.customerEmail || '';
        const emailPlaceholder = customerEmail ? '' : (t && t.notify_email) || 'Email';
        const submitLabel = (t && t.notify_email_send) || 'Send';

        let messageBody;
        if (t && t.notify_message_first) {
          let title = productTitle;
          if (variantTitle && variantTitle !== 'Default Title') title += ' - ' + variantTitle;
          messageBody = t.notify_message_first + title + (t.notify_message_last || '') + notifyUrl;
        } else {
          let title = productTitle;
          if (variantTitle && variantTitle !== 'Default Title') title += ' - ' + variantTitle;
          messageBody = 'Please notify me when ' + title + ' is back in stock: ' + notifyUrl;
        }

        notifyFormInputs.innerHTML = [
          '<input class="notify-email" id="contact[email]" name="contact[email]" type="email"',
          '  placeholder="' + emailPlaceholder + '" value="' + customerEmail + '" required>',
          '<input name="challenge" type="hidden" value="false">',
          '<input class="notify_form_message" name="contact[body]" type="hidden"',
          '  data-body="' + messageBody + '" value="' + messageBody + '">',
          '<input class="global-button global-button--primary" type="submit" value="' + submitLabel + '">',
        ].join('\n');

        notifyForm.style.display = '';
      } else {
        notifyForm.style.display = 'none';
        notifyFormInputs.innerHTML = '';
      }
    }

    /**
     * Keep third-party apps (e.g. Appikon/Subscribe-It) in sync with bundle base variant.
     * Many apps detect current variant from ?variant=... and/or [name="id"] inputs.
     */
    function syncBundleVariantForApps(baseVariantId) {
      if (!baseVariantId) return;

      const baseId = String(baseVariantId);

      // 1) Maintain ?variant=<id> in URL (without reloading).
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== baseId) {
          url.searchParams.set('variant', baseId);
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
      } catch (err) {
        // no-op in older browsers / malformed URL edge cases
      }

      // 2) Expose current variant via a hidden [name="id"] field.
      let appVariantInput = bundleBuilder.querySelector('#bundle-current-variant-id');
      if (!appVariantInput) {
        appVariantInput = document.createElement('input');
        appVariantInput.type = 'hidden';
        appVariantInput.name = 'id';
        appVariantInput.id = 'bundle-current-variant-id';
        bundleBuilder.appendChild(appVariantInput);
      }
      appVariantInput.value = baseId;
      appVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

      // 3) Keep _SIConfig's selected variant aligned when available.
      if (
        window._SIConfig &&
        window._SIConfig.product &&
        Array.isArray(window._SIConfig.product.variants)
      ) {
        const match = window._SIConfig.product.variants.find(v => String(v.id) === baseId);
        if (match) {
          window._SIConfig.product.selected_or_first_available_variant = match;
        }
      }

      // 4) For bundle pages, re-map Appikon popup variants to the base component variants.
      // Appikon normally reads `product.variants` from the current PDP product object, but for
      // bundles the sellable base variants live in bundle config and use different IDs.
      const baseComponent = bundleConfig.components.find(c => c.is_base);
      if (window.SI && window.SI.popup && baseComponent && Array.isArray(baseComponent.variants)) {
        const existingProduct = window.SI.popup.product || (window._SIConfig && window._SIConfig.product) || {};
        const mappedVariants = baseComponent.variants.map(v => ({
          id: v.id,
          title: v.title,
          available: !!v.available,
          // Appikon checks this when `require_inventory_management` is true.
          inventory_management: 'shopify',
          // Keep simple qty semantics for OOS detection.
          inventory_quantity: v.available ? 1 : 0,
          inventory_policy: 'deny',
          option1: v.title
        }));
        const selectedVariant = mappedVariants.find(v => String(v.id) === baseId) || mappedVariants[0];
        const mappedProduct = Object.assign({}, existingProduct, {
          variants: mappedVariants,
          options: ['Title'],
          selected_or_first_available_variant: selectedVariant
        });

        window.SI.popup.product = mappedProduct;
        window.SI.popup.settings = window.SI.popup.settings || {};
        window.SI.popup.settings.product = mappedProduct;
        window.SI.popup._variantsById = {};
        window.SI.popup._variantsByTitle = {};
        if (typeof window.SI.popup.processProductVariants === 'function') {
          window.SI.popup.processProductVariants(mappedProduct);
        }
      }

      // 5) Ensure an Appikon trigger button exists in bundle actions.
      const baseInfo = getAvailabilityFromConfig(baseVariantId);
      const baseIsUnavailable = !!(baseInfo && baseInfo.available === false);
      const actionsEl = bundleBuilder.querySelector('.bundle-builder__actions');
      if (actionsEl) {
        let siTrigger = actionsEl.querySelector('#SI_trigger');
        if (!siTrigger) {
          siTrigger = document.createElement('button');
          siTrigger.type = 'button';
          siTrigger.id = 'SI_trigger';
          // Do NOT use SI_trigger class. Appikon's delegated click handler on that class
          // can run before its form object is initialized on bundle pages.
          siTrigger.className = 'appikon-button';
          const label = window._SIConfig && window._SIConfig.button && window._SIConfig.button.caption
            ? window._SIConfig.button.caption
            : 'NOTIFY ME WHEN AVAILABLE';
          siTrigger.textContent = label;
          // Place after ATC for expected UX.
          actionsEl.appendChild(siTrigger);
        }
        siTrigger.setAttribute('data-variant-id', String(baseVariantId));
        siTrigger.style.display = baseIsUnavailable ? '' : 'none';

        // Pre-warm Appikon form creation when button becomes visible so first user click
        // can open immediately instead of only initializing internal UI state.
        if (baseIsUnavailable && window.SI && window.SI.popup) {
          const popup = window.SI.popup;
          if (!popup.form && typeof popup.createUI === 'function') {
            try {
              popup.createUI();
            } catch (err) {
              // eslint-disable-next-line no-console
              console.warn('Bundle Appikon prewarm failed:', err);
            }
          }
        }

        if (!siTrigger.dataset.bundleBisBound) {
          siTrigger.addEventListener('click', function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const triggerVariantId = parseInt(this.getAttribute('data-variant-id'), 10);
            if (!triggerVariantId || !window.SI || !window.SI.popup) return;

            const popup = window.SI.popup;
            try {
              const openPopupForVariant = () => {
                if (!popup.form) return false;
                if (typeof popup.form.selectVariant === 'function') {
                  popup.form.selectVariant(triggerVariantId);
                }
                if (typeof popup.show === 'function') {
                  popup.show({ variantId: triggerVariantId });
                } else if (typeof popup.form.show === 'function') {
                  popup.form.show({ variantId: triggerVariantId });
                }
                return true;
              };

              // Ensure Appikon UI/form exists.
              if (!popup.form && typeof popup.createUI === 'function') {
                popup.createUI();
              }

              // If form isn't ready yet, wait briefly and open once it is.
              if (!openPopupForVariant()) {
                let retries = 40;
                const timer = setInterval(() => {
                  if (openPopupForVariant() || retries <= 0) {
                    clearInterval(timer);
                  }
                  retries -= 1;
                }, 50);
              } else {
                // Some Appikon states need one extra nudge after initial open.
                setTimeout(() => {
                  const modal = document.getElementById('SIModal');
                  const isVisible = modal && (
                    modal.classList.contains('in')
                    || modal.style.display === 'block'
                    || modal.getAttribute('aria-hidden') === 'false'
                  );
                  if (!isVisible) {
                    openPopupForVariant();
                  }
                }, 120);
              }
            } catch (err) {
              // Avoid hard crash if Appikon internals change.
              // eslint-disable-next-line no-console
              console.warn('Bundle Appikon trigger failed:', err);
            }
          });
          siTrigger.dataset.bundleBisBound = '1';
        }
      }

      // 6) Ask the Appikon popup/button logic to re-evaluate immediately when possible.
      if (window.SI && window.SI.popup) {
        if (typeof window.SI.popup.toggleForVariant === 'function') {
          window.SI.popup.toggleForVariant(baseVariantId);
        } else if (typeof window.SI.popup.variantChanged === 'function') {
          window.SI.popup.variantChanged();
        }
      }
    }

    /**
     * Check if all required components have variants selected
     */
    function checkBundleReady() {
      let isReady = true;
      const missingComponents = [];
      const choiceGroups = {};

      bundleConfig.components.forEach((component, index) => {
        // Skip components that are currently hidden (no allowed variants)
        const componentEl = bundleBuilder.querySelector(`[data-component-index="${index}"]`);
        if (componentEl && componentEl.style.display === 'none') {
          return;
        }

        // Skip if component has fixed variant (already set)
        if (component.component_variant_id) return;
        
        // For components with allowed_quantities, check if quantity is set (even if 0)
        if (component.allowed_quantities) {
          if (selectedQuantities[index] === undefined) {
            isReady = false;
            missingComponents.push(component.component_product_handle + ' (quantity)');
          }
          // Still require variant selection if quantity > 0
          if (selectedQuantities[index] > 0 && !selectedVariants[index]) {
            isReady = false;
            missingComponents.push(component.component_product_handle + ' (variant)');
          }
          return;
        }

        // Check if variant is selected (for required components)
        if (!selectedVariants[index]) {
          isReady = false;
          missingComponents.push(component.component_product_handle);
        }

        // Track choice groups (only for visible components)
        if (component.choice_group) {
          const groupKey = component.choice_group;
          if (!choiceGroups[groupKey]) {
            choiceGroups[groupKey] = { qty: 0, min: component.choice_min || 0, max: component.choice_max || null };
          }
          const qtyVal = selectedQuantities[index] || 0;
          choiceGroups[groupKey].qty += qtyVal;
          // Store min/max if higher requirement appears
          if (component.choice_min && component.choice_min > choiceGroups[groupKey].min) {
            choiceGroups[groupKey].min = component.choice_min;
          }
          if (component.choice_max && (!choiceGroups[groupKey].max || component.choice_max < choiceGroups[groupKey].max)) {
            choiceGroups[groupKey].max = component.choice_max;
          }
        }
      });

      // Validate choice groups
      Object.entries(choiceGroups).forEach(([groupKey, info]) => {
        const { qty, min, max } = info;
        if ((min && qty < min) || (max !== null && qty > max)) {
          isReady = false;
          missingComponents.push(`${groupKey} (choice)`);
        }
      });

      // Check whether the selected base variant is OOS — if so, block add-to-cart
      const baseCompConfig = bundleConfig.components.find(c => c.is_base);
      const baseVarId = baseCompConfig ? selectedVariants[baseCompConfig.index] : null;
      let baseIsOOS = false;
      if (baseVarId) {
        const availInfo = getAvailabilityFromConfig(baseVarId);
        if (availInfo && availInfo.available === false) {
          isReady = false;
          baseIsOOS = true;
        }
      }

      // Enable/disable add to cart button
      if (addToCartBtn) {
        addToCartBtn.disabled = !isReady;
      }

      // Show error if not ready (suppress the "please select" message when base is OOS —
      // the Notify Me form handles that case instead)
      if (errorDiv) {
        if (!isReady && missingComponents.length > 0 && !baseIsOOS) {
          errorDiv.textContent = `Please select variants for: ${missingComponents.join(', ')}`;
          errorDiv.style.display = 'block';
        } else {
          errorDiv.style.display = 'none';
        }
      }

      // Show / hide the Notify Me form
      updateBundleNotifyMe(baseVarId);
      // Keep app-based notify widgets in sync with selected base variant.
      syncBundleVariantForApps(baseVarId);

      return isReady;
    }

    /**
     * Format price in cents to display format
     */
    function formatPrice(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) {
        return '$0.00';
      }
      
      // Use theme's price formatting if available
      if (window.theme && window.theme.moneyFormat) {
        return window.theme.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2));
      }
      
      // Fallback to simple formatting
      return '$' + (cents / 100).toFixed(2);
    }

    /**
     * Calculate component price (original and discounted)
     */
    function calculateComponentPrice(component, variantId, quantity) {
      if (!component || !variantId || !quantity || quantity === 0) {
        return {
          originalPrice: 0,
          discountedPrice: 0,
          savings: 0,
          hasDiscount: false
        };
      }

      // Price using the same base-line mapping used by add-to-cart so PDP totals
      // always match the cart payload (e.g., base $700 with effective qty 2 => $1400).
      const priceLines = component.is_base
        ? getMappedBaseCartLines(component, variantId, quantity)
        : [{ id: variantId, quantity }];

      const originalPrice = priceLines.reduce((sum, line) => {
        const lineVariantId = parseInt(line.id, 10);
        const lineVariant = component.variants && component.variants.find(v => v.id === lineVariantId);
        if (!lineVariant) {
          debugWarn(`Variant ${line.id} not found in component ${component.index}`);
          return sum;
        }
        return sum + (lineVariant.price * line.quantity);
      }, 0);

      if (originalPrice === 0) {
        return {
          originalPrice: 0,
          discountedPrice: 0,
          savings: 0,
          hasDiscount: false
        };
      }

      let discountedPrice = originalPrice;
      let hasDiscount = false;

      // Apply discount if applicable
      if (component.apply_discount && 
          bundleConfig.discount_type === 'percent' && 
          bundleConfig.discount_value) {
        const discountMultiplier = bundleConfig.discount_value / 100;
        discountedPrice = Math.round(originalPrice * (1 - discountMultiplier));
        hasDiscount = true;
      }

      const savings = originalPrice - discountedPrice;

      return {
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        savings: savings,
        hasDiscount: hasDiscount
      };
    }

    /**
     * Update price display for a specific component
     */
    function updateComponentPriceDisplay(componentIndex) {
      const component = bundleConfig.components[componentIndex];
      if (!component) return;

      const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
      if (!componentEl) return;

      const priceEl = componentEl.querySelector('.bundle-component__price');
      if (!priceEl) return;

      const variantId = component.component_variant_id || selectedVariants[componentIndex];
      const quantity = selectedQuantities[componentIndex] !== undefined 
        ? selectedQuantities[componentIndex] 
        : (component.default_qty || component.min_qty || 1);

      // Skip if quantity is 0
      if (quantity === 0) {
        priceEl.querySelector('.bundle-component__price-original').textContent = '';
        priceEl.querySelector('.bundle-component__price-discounted').textContent = '';
        priceEl.querySelector('.bundle-component__price-savings').textContent = '';
        return;
      }

      const priceData = calculateComponentPrice(component, variantId, quantity);

      const originalPriceEl = priceEl.querySelector('.bundle-component__price-original');
      const discountedPriceEl = priceEl.querySelector('.bundle-component__price-discounted');
      const savingsEl = priceEl.querySelector('.bundle-component__price-savings');

      // Always show just the final price (discounted if discount applies, otherwise original)
      // No strikethrough, no discount percentage, no savings text
      const finalPrice = priceData.hasDiscount ? priceData.discountedPrice : priceData.originalPrice;
      
      originalPriceEl.textContent = '';
      originalPriceEl.classList.remove('has-discount');
      discountedPriceEl.textContent = formatPrice(finalPrice);
      savingsEl.textContent = '';
    }

    /**
     * Update discount display for add-on components (optional/accessory)
     */
    function updateComponentDiscountDisplay(componentIndex) {
      const component = bundleConfig.components[componentIndex];
      if (!component) return;

      // Only show discount for optional/accessory components (not base or required)
      if (component.is_base || component.role === 'required') {
        return;
      }

      // Only show if component has discount applied
      if (!component.apply_discount || bundleConfig.discount_type !== 'percent' || !bundleConfig.discount_value) {
        return;
      }

      const componentEl = bundleBuilder.querySelector(`[data-component-index="${componentIndex}"]`);
      if (!componentEl) return;

      const discountEl = componentEl.querySelector('.bundle-component__discount');
      if (!discountEl) return;

      // Always show discount (even if not selected)
      discountEl.style.display = '';

      // Get variant and quantity to calculate price
      const variantId = component.component_variant_id || selectedVariants[componentIndex];
      const quantity = selectedQuantities[componentIndex] !== undefined 
        ? selectedQuantities[componentIndex] 
        : (component.default_qty || component.min_qty || 1);

      // Update discount text with price (always show price, even if not selected)
      const discountTextEl = discountEl.querySelector('.bundle-component__discount-text');
      if (discountTextEl) {
        let discountText = `Bundle and save ${bundleConfig.discount_value}%`;
        
        // Determine which variant to use for price display
        let priceVariantId = variantId;
        
        // If no variant selected, use first available variant
        if (!priceVariantId && component.variants && component.variants.length > 0) {
          priceVariantId = component.variants[0].id;
        }
        
        // Always use quantity 1 for discount display (show per-unit price, not total)
        const priceQuantity = 1;
        
        // Calculate and show price if we have a variant
        if (priceVariantId) {
          const priceData = calculateComponentPrice(component, priceVariantId, priceQuantity);
          if (priceData.hasDiscount && priceData.discountedPrice > 0) {
            discountText += ` - ${formatPrice(priceData.discountedPrice)}`;
          } else if (priceData.originalPrice > 0) {
            // Show original price if no discount applies
            discountText += ` - ${formatPrice(priceData.originalPrice)}`;
          }
        }
        
        discountTextEl.textContent = discountText;
      }
    }

    /**
     * Update all component price displays
     */
    function updateBundlePriceDisplay() {
      bundleConfig.components.forEach((component, index) => {
        updateComponentPriceDisplay(index);
        updateComponentDiscountDisplay(index);
      });
    }

    /**
     * Calculate total bundle price and update main product price display
     */
    function updateTotalBundlePrice() {
      let totalOriginalPrice = 0;
      let totalDiscountedPrice = 0;
      let totalSavings = 0;
      let hasAnyDiscount = false;

      // Calculate total price across all components
      bundleConfig.components.forEach((component, index) => {
        const variantId = component.component_variant_id || selectedVariants[index];
        const quantity = selectedQuantities[index] !== undefined 
          ? selectedQuantities[index] 
          : (component.default_qty || component.min_qty || 1);
        
        // Skip components with quantity 0
        if (quantity === 0) return;
        
        const priceData = calculateComponentPrice(component, variantId, quantity);
        totalOriginalPrice += priceData.originalPrice;
        totalDiscountedPrice += priceData.discountedPrice;
        totalSavings += priceData.savings;
        if (priceData.hasDiscount) {
          hasAnyDiscount = true;
        }
      });

      // Find the main product price display element - try multiple selectors
      let $priceUI = $('.price-ui[data-price-ui], [data-price-ui]');
      let $customDiscount = $('.custom-discount-pricing');
      let $priceDisplay = $('.modal_price, .product-details .price');
      
      // Ensure body has 'product' class so CSS selector body.product .modal_price span applies
      // This is needed because bundle templates have body class 'product-bundle-poc' instead of 'product'
      if (!$('body').hasClass('product')) {
        $('body').addClass('product');
      }
      
      // Remove loading class to show price
      $priceUI.removeClass('price-ui--loading');
      
      // Calculate final price (discounted if discount applies, otherwise original)
      const finalPrice = hasAnyDiscount && totalSavings > 0 ? totalDiscountedPrice : totalOriginalPrice;
      const formattedPrice = formatPrice(finalPrice);
      
      // Handle price-ui structure (most common) - matches price-ui-templates.liquid structure
      if ($priceUI.length > 0) {
        // Remove any custom-discount-pricing structure
        const $existingCustomDiscount = $priceUI.find('.custom-discount-pricing');
        if ($existingCustomDiscount.length > 0) {
          $existingCustomDiscount.remove();
        }
        
        // Find the price span with data-price attribute
        let $priceSpan = $priceUI.find('span.price[data-price]');
        
        // If price span doesn't exist, find any [data-price] element
        if ($priceSpan.length === 0) {
          const $dataPriceEl = $priceUI.find('[data-price]');
          if ($dataPriceEl.length > 0) {
            // If it's not already a span.price, wrap it
            if (!$dataPriceEl.is('span.price')) {
              const priceText = $dataPriceEl.text();
              $dataPriceEl.replaceWith(`<span class="price" data-price>${priceText}</span>`);
              $priceSpan = $priceUI.find('span.price[data-price]');
            } else {
              $priceSpan = $dataPriceEl;
            }
          } else {
            // Create the price span structure
            $priceSpan = $('<span class="price" data-price></span>');
            $priceUI.append($priceSpan);
          }
        }
        
        // Preserve existing unit-pricing and sold_out elements
        const $unitPricing = $priceUI.find('span.unit-pricing[data-unit-pricing]');
        const $soldOut = $priceUI.find('span.sold_out');
        
        // Create money element with proper structure
        const $moneyEl = $('<span class="money" data-price=""></span>').text(formattedPrice);
        
        // Update price - always show simple price without discount indicators
        // Structure: <span class="price" data-price><span class="money" data-price="">$XXX.XX</span></span>
        $priceSpan.html($moneyEl);
        $priceSpan.removeClass('price--sale');
        
        // Remove compare-at-price span (no strikethrough)
        $priceUI.find('span.compare-at-price[data-compare-at-price]').remove();
        
        // Ensure unit-pricing span exists (empty) to match normal template structure
        if ($unitPricing.length === 0) {
          // Create empty unit-pricing span for structure consistency
          $priceUI.append('<span class="unit-pricing" data-unit-pricing></span>');
        }
        // sold_out is conditionally rendered, preserve if it exists
      } 
      // Handle custom-discount-pricing structure - remove it and show simple price
      else if ($customDiscount.length > 0) {
        // Remove custom-discount-pricing entirely
        $customDiscount.remove();
        
        // Try to find or create price-ui structure
        let $priceUI = $('.price-ui[data-price-ui], [data-price-ui]');
        if ($priceUI.length === 0) {
          // Create basic price structure
          $priceUI = $('<div class="price-ui" data-price-ui></div>');
          $customDiscount.parent().append($priceUI);
        }
        
        let $priceSpan = $priceUI.find('span.price[data-price]');
        if ($priceSpan.length === 0) {
          $priceSpan = $('<span class="price" data-price></span>');
          $priceUI.append($priceSpan);
        }
        
        const $moneyEl = $('<span class="money" data-price=""></span>').text(formattedPrice);
        $priceSpan.html($moneyEl);
        $priceSpan.removeClass('price--sale');
      }
      // Handle standard price structure (fallback)
      else if ($priceDisplay.length > 0) {
        $priceDisplay.each(function() {
          const $priceEl = $(this);
          
          // Always show simple price without strikethrough or sale class
          const currentPriceHtml = `<span class="current_price"><span class="money">${formattedPrice}</span></span>`;
          $priceEl.html(currentPriceHtml);
          $priceEl.removeClass('sale');
        });
      } else {
        debugWarn('⚠️ Price display element not found');
      }
    }

    function validateInventoryBeforeAdd(items) {
      return Promise.all(items.map(item =>
        fetchVariantAvailability(item.id).then(({ available, quantity }) => ({
          id: item.id,
          requested: item.quantity,
          available,
          quantity
        }))
      )).then(results => {
        const insufficient = results.filter(r => {
          const isOut = r.available === false;
          const canCheckQty = typeof r.quantity === 'number';
          return isOut || (canCheckQty && r.requested > r.quantity);
        });
        return { ok: insufficient.length === 0, insufficient };
      });
    }

    /**
     * Add bundle to cart
     */
    function generateBundleInstanceId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      const time = Date.now().toString(36);
      const random = Math.random().toString(36).slice(2);
      return `bundle_${time}_${random}`;
    }

    function addBundleToCart() {
      if (!checkBundleReady()) {
        return;
      }

      const bundleInstanceId = generateBundleInstanceId();

      function createBundleCartItem(component, variantId, quantity, options = {}) {
        const isBaseValue = options.isBaseOverride !== undefined
          ? options.isBaseOverride
          : (component.is_base ? "true" : "false");
        const properties = {
          _bundle_id: bundleConfig.bundle_id,
          _bundle_instance_id: bundleInstanceId,
          _bundle_name: bundleConfig.bundle_name,
          _discount_type: bundleConfig.discount_type,
          _discount_value: bundleConfig.discount_value.toString(),
          _component_index: component.index.toString(),
          _component_role: component.role,
          _component_display_title: component.component_display_title || "",
          _choice_group: component.choice_group || "",
          _choice_min: component.choice_min !== null && component.choice_min !== undefined ? String(component.choice_min) : "",
          _choice_max: component.choice_max !== null && component.choice_max !== undefined ? String(component.choice_max) : "",
          _is_choice_required: component.choice_group && Number(component.choice_min) >= 1 ? "true" : "false",
          _is_base: isBaseValue,
          _apply_discount: component.apply_discount ? "true" : "false"
        };

        if (options.bundleDisplayColor) {
          properties._bundle_display_color = options.bundleDisplayColor;
        }
        if (options.bundleDisplaySize) {
          properties._bundle_display_size = options.bundleDisplaySize;
        }
        if (options.hiddenBundleComponent) {
          properties._bundle_hidden_component = "true";
        }

        return {
          id: variantId,
          quantity: quantity,
          properties
        };
      }

      // Build items array
      const items = bundleConfig.components.reduce((acc, component) => {
        // Use fixed variant ID if available, otherwise use selected variant
        let variantId = component.component_variant_id || selectedVariants[component.index];
        // Use tracked quantity if available, otherwise use default/min_qty
        const quantity = selectedQuantities[component.index] !== undefined 
          ? selectedQuantities[component.index] 
          : (component.default_qty || component.min_qty || 1);

        // Fallback: if quantity > 0 but no variant selected, pick first available variant (skip if none available)
        if (!variantId && quantity > 0 && Array.isArray(component.variants) && component.variants.length) {
          const fallbackVariant = component.variants.find(v => v.available) || component.variants[0];
          if (fallbackVariant) {
            variantId = fallbackVariant.id;
            selectedVariants[component.index] = variantId;
            if (isDebugEnabled()) {
              warnLog('⚠️ No variant selected; using fallback variant', {
                componentIndex: component.index,
                componentHandle: component.component_product_handle,
                fallbackVariantId: variantId,
                quantity
              });
            }
          } else {
            if (isDebugEnabled()) {
              errorLog('❌ No available variants for component with quantity > 0', {
                componentIndex: component.index,
                componentHandle: component.component_product_handle,
                quantity
              });
            }
            return acc;
          }
        }

        if (quantity > 0 && !variantId) {
          if (isDebugEnabled()) {
            errorLog('❌ Cannot add component without variant', {
              componentIndex: component.index,
              componentHandle: component.component_product_handle,
              quantity
            });
          }
          return acc;
        }
        
        // Skip components with quantity 0
        if (quantity === 0) return acc;

        if (component.is_base) {
          const baseLines = getMappedBaseCartLines(component, variantId, quantity);
          const selectedBaseVariant = getBaseVariantById(variantId);
          const selectedBaseProfile = getBaseVariantProfile(selectedBaseVariant);
          const isOffsetSplit = selectedBaseProfile.profile === 'offset' && baseLines.length > 1;

          baseLines.forEach(line => {
            if (isOffsetSplit) {
              const isPrimaryDisplayLine = acc.filter(item => item.properties && item.properties._bundle_instance_id === bundleInstanceId && item.properties._component_role === component.role).length === 0;
              acc.push(createBundleCartItem(component, line.id, line.quantity, {
                isBaseOverride: isPrimaryDisplayLine ? "true" : "false",
                bundleDisplayColor: isPrimaryDisplayLine ? selectedBaseProfile.color : undefined,
                bundleDisplaySize: isPrimaryDisplayLine ? "25L + 35L" : undefined,
                hiddenBundleComponent: !isPrimaryDisplayLine
              }));
            } else {
              acc.push(createBundleCartItem(component, line.id, line.quantity));
            }
          });
          return acc;
        }

        acc.push(createBundleCartItem(component, variantId, quantity));
        return acc;
      }, []);

      if (isDebugEnabled()) {
        const discountMetaSummary = items.map(item => ({
          id: item.id,
          quantity: item.quantity,
          bundle_id: item.properties && item.properties._bundle_id,
          bundle_instance_id: item.properties && item.properties._bundle_instance_id,
          component_role: item.properties && item.properties._component_role,
          is_base: item.properties && item.properties._is_base,
          apply_discount: item.properties && item.properties._apply_discount,
          discount_type: item.properties && item.properties._discount_type,
          discount_value: item.properties && item.properties._discount_value
        }));
        discountDebugLog('🧪 Bundle discount pre-add summary', {
          bundle_id: bundleConfig.bundle_id,
          bundle_name: bundleConfig.bundle_name,
          discount_type: bundleConfig.discount_type,
          discount_value: bundleConfig.discount_value,
          lines: discountMetaSummary
        });
      }

      if (isDebugEnabled()) {
        // Compute total expected quantities for shared aux roles to catch mismatches
        const aux4 = bundleConfig.components.find(c => c.shared_qty_role === 'aux-4l');
        const aux5 = bundleConfig.components.find(c => c.shared_qty_role === 'aux-5l');
        const aux4Idx = aux4 ? bundleConfig.components.indexOf(aux4) : -1;
        const aux5Idx = aux5 ? bundleConfig.components.indexOf(aux5) : -1;
        const aux4Qty = aux4Idx >= 0 ? (selectedQuantities[aux4Idx] || 0) : 0;
        const aux5Qty = aux5Idx >= 0 ? (selectedQuantities[aux5Idx] || 0) : 0;

        infoLog('Add to cart payload (debug)', {
          selectedQuantities: { ...selectedQuantities },
          selectedVariants: { ...selectedVariants },
          items,
          sharedAuxSelectedValue,
          aux4Qty,
          aux5Qty
        });
      }

      if (isDebugEnabled()) {
        debugLog('Add to cart payload', {
          selectedQuantities: { ...selectedQuantities },
          selectedVariants: { ...selectedVariants },
          items
        });
      }

      // Disable button during request
      const buttonTextEl = getButtonTextElement(addToCartBtn);
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        if (buttonTextEl) {
          buttonTextEl.textContent = 'Adding...';
        }
      }
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }

      validateInventoryBeforeAdd(items).then(result => {
        if (!result.ok) {
          if (errorDiv) {
            errorDiv.textContent = 'Not enough inventory for one or more bundle items.';
            errorDiv.style.display = 'block';
          }
          result.insufficient.forEach(r => {
            warnLog(`⚠️ Insufficient inventory for variant ${r.id}: requested ${r.requested}, available ${r.available}`);
          });
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            if (buttonTextEl) {
              buttonTextEl.textContent = getButtonLabel(addToCartBtn);
            }
          }
          return;
        }

        const payload = { items };

        // Add to cart with detailed logging on error
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        })
        .then(async response => {
          const text = await response.text();
          if (isDebugEnabled()) {
            infoLog('Add to cart response', {
              status: response.status,
              ok: response.ok,
              body: text
            });
          }
          if (!response.ok) {
            throw new Error(`Status ${response.status}: ${text || 'Unknown error'}`);
          }
          let data;
          try {
            data = text ? JSON.parse(text) : {};
          } catch (e) {
            throw new Error(`Invalid JSON response: ${text}`);
          }
          if (data && data.errors) {
            throw new Error(data.errors);
          }
          return data;
        })
        .then(() => {
          if (isDebugEnabled()) {
            fetch('/cart.js')
              .then(r => r.json())
              .then(cart => {
                const rows = (cart.items || [])
                  .filter(i => i.properties && i.properties._bundle_instance_id === bundleInstanceId)
                  .map(i => ({
                    title: i.product_title,
                    variant: i.variant_title,
                    bundle_id: i.properties && i.properties._bundle_id,
                    is_base: i.properties && i.properties._is_base,
                    apply_discount: i.properties && i.properties._apply_discount,
                    discount_type: i.properties && i.properties._discount_type,
                    discount_value: i.properties && i.properties._discount_value,
                    original_line_price: i.original_line_price,
                    final_line_price: i.final_line_price,
                    discounts_count: (i.line_level_discount_allocations || []).length
                  }));
                discountDebugLog('🧪 Bundle discount cart.js snapshot', {
                  bundle_instance_id: bundleInstanceId,
                  line_count: rows.length,
                  rows
                });
              })
              .catch(err => {
                discountDebugLog('⚠️ Failed cart.js debug snapshot', err && err.message ? err.message : err);
              });
          }

          // Reset button state before redirect/refresh
          const buttonTextElAfter = getButtonTextElement(addToCartBtn);
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            if (buttonTextElAfter) {
              buttonTextElAfter.textContent = getButtonLabel(addToCartBtn);
            }
          }
          
          // Success - redirect to cart or refresh
          if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
            window.theme.cart.refresh();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(error => {
          errorLog('Error adding bundle to cart:', error);
          if (errorDiv) {
            errorDiv.textContent = `Error: ${error.message || 'Failed to add bundle to cart'}`;
            errorDiv.style.display = 'block';
          }
          const buttonTextElAfter = getButtonTextElement(addToCartBtn);
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            if (buttonTextElAfter) {
              buttonTextElAfter.textContent = getButtonLabel(addToCartBtn);
            }
          }
        });
      });
    }

    // Attach add to cart handler
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', addBundleToCart);
    }
    /**
     * Navigate gallery to image tagged with selected optional component variant
     * Uses component tags from image alt text in format: "Text [component-handle|variant-key]"
     */
    function navigateToOptionalComponentImage() {
      const runId = ++navigationRunId;
      debugGroup('🖼️ Navigating gallery to optional component image');
      
      if (!window.bundleBaseProduct || !window.bundleBaseProduct.images) {
        debugWarn('⚠️ bundleBaseProduct.images not available');
        debugGroupEnd();
        return;
      }
      
      const { $gallery } = getGalleryElements();
      if (!$gallery || !$gallery.length) {
        debugWarn('⚠️ Gallery not found');
        debugGroupEnd();
        return;
      }
      
      // Get all selected component variants (check optional, accessory, AND required)
      const selectedComponentVariants = [];
      let baseComponentVariant = null;
      
      bundleConfig.components.forEach((component, index) => {
        const componentEl = bundleBuilder.querySelector(`.bundle-component[data-component-index="${index}"]`);
        if (!componentEl) return;
        
        const hiddenSelect = componentEl.querySelector(`#variant-select-${index}`);
        
        // Get base component variant for logging
        if (component.is_base && hiddenSelect && hiddenSelect.value) {
          const variantId = parseInt(hiddenSelect.value);
          const variantOption = hiddenSelect.querySelector(`option[value="${variantId}"]`);
          if (variantOption) {
            const variantTitle = variantOption.textContent.trim();
            const variantParts = variantTitle.toLowerCase().split('/').map(s => s.trim());
            baseComponentVariant = {
              variantKey: variantParts.join('|'),
              variantColor: variantParts[0] || null,
              variantSize: variantParts[variantParts.length - 1] || null,
              productHandle: component.component_product_handle ? component.component_product_handle.toLowerCase() : null
            };
          }
        }
        
        // Check all component types that might have tagged images
        if (component.role === 'optional' || component.role === 'accessory' || component.role === 'required') {
          // Skip components with quantity 0 (they're not actually selected)
          const quantity = selectedQuantities[index] !== undefined ? selectedQuantities[index] : null;
          if (component.allowed_quantities && quantity === 0) {
            return; // Skip this component if quantity is 0
          }
          
          // Check if component has a selected variant
          if (hiddenSelect && hiddenSelect.value) {
            const variantId = parseInt(hiddenSelect.value);
            let variantTitle = null;
            
            // Handle both <select> and <input> elements
            if (hiddenSelect.tagName === 'SELECT') {
              const variantOption = hiddenSelect.querySelector(`option[value="${variantId}"]`);
              if (variantOption) {
                variantTitle = variantOption.textContent.trim();
              }
            } else if (hiddenSelect.tagName === 'INPUT') {
              // For input elements, get variant title from bundle config
              const variant = component.variants && component.variants.find(v => v.id === variantId);
              if (variant) {
                variantTitle = variant.title;
              }
            }
            
            if (variantTitle) {
              const variantParts = variantTitle.toLowerCase().split('/').map(s => s.trim());
              
              selectedComponentVariants.push({
                variantKey: variantParts.join('|'),
                variantColor: variantParts[0] || null,
                variantSize: variantParts[variantParts.length - 1] || null,
                productHandle: component.component_product_handle ? component.component_product_handle.toLowerCase() : null,
                quantity: quantity
              });
            }
          } 
          // If component has quantity selection but no variant (like aux pox with quantity only)
          else if (component.allowed_quantities && selectedQuantities[index] !== undefined && selectedQuantities[index] > 0) {
            // Get the selected color if available
            const colorSwatch = componentEl.querySelector('.swatch-element.selected, .swatch input:checked');
            const colorValue = colorSwatch ? (colorSwatch.dataset.value || colorSwatch.value) : null;
            
            selectedComponentVariants.push({
              variantKey: colorValue ? colorValue.toLowerCase() : null,
              variantColor: colorValue ? colorValue.toLowerCase() : null,
              variantSize: null,
              productHandle: component.component_product_handle ? component.component_product_handle.toLowerCase() : null,
              quantity: selectedQuantities[index]
            });
          }
        }
      });
      
      // Keep this log - helps with creating image tags
      // Format: "Image Description [tag1, tag2, tag3]"
      // All tags should be in one bracket, comma-separated
      const allTags = [];
      
      // Add base component variant if present
      if (baseComponentVariant) {
        allTags.push(`${baseComponentVariant.productHandle}:${baseComponentVariant.variantKey}`);
      }
      
      // Add optional/required/accessory component variants
      selectedComponentVariants.forEach(v => {
        const tag = `${v.productHandle}:${v.variantKey}${v.quantity !== null && v.quantity !== undefined ? `|qty:${v.quantity}` : ''}`;
        allTags.push(tag);
      });
      
      if (allTags.length === 0) {
        altTagLog('Selected variants: (none)');
        debugLog('No components selected');
        debugGroupEnd();
        return;
      }
      
      // Output in the correct format for alt tag: "Image Description [tag1, tag2, tag3]"
      const altTagFormat = `[${allTags.join(', ')}]`;
      if (altTagFormat === lastNavigationSignature) {
        debugLog('Skipping navigation; selection unchanged');
        debugGroupEnd();
        return;
      }
      lastNavigationSignature = altTagFormat;

      const isAltTagVerbose = window.bundleBuilderAltTagVerbose === true ||
        (window.localStorage && window.localStorage.getItem('bundleBuilderAltTagVerbose') === 'true');

      const showCombinedAltTag = isCombinedAltTagEnabled();

      // If shared-qty Aux is active, output combined tags for all sizes (copy/paste ready).
      const baseComponent = bundleConfig.components.find(c => c.is_base);
      if (showCombinedAltTag && baseComponent && baseComponentVariant && baseComponentVariant.variantColor) {
        const color = baseComponentVariant.variantColor.toLowerCase();
        const baseHandle = (baseComponent.component_product_handle || '').toLowerCase();

        const aux4 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-4l');
        const aux5 = sharedQtyComponents.find(({ comp }) => comp.shared_qty_role === 'aux-5l');

        const variantsForColor = baseComponent.variants.filter(v => {
          const title = (v.title || '').toLowerCase();
          return title.startsWith(`${color} / `);
        });

        const getAllowedQuantitiesFor = (variantId, componentHandle, componentIndex, fallback) => {
          const rule = Array.isArray(bundleConfig.quantity_rules)
            ? bundleConfig.quantity_rules.find(r =>
                r.trigger_variant_id === variantId &&
                r.component_handle === componentHandle
              )
            : null;
          const qtyString = rule && rule.allowed_quantities
            ? rule.allowed_quantities
            : fallback;
          return (qtyString || '')
            .split(',')
            .map(q => parseInt(q.trim(), 10))
            .filter(q => !isNaN(q));
        };

        const tagLines = [];
        variantsForColor.forEach(variant => {
          const parts = (variant.title || '').toLowerCase().split(' / ').map(s => s.trim());
          const sizePart = parts[1] || '';
          const baseTag = `${baseHandle}:${color}|${sizePart}`;

          let auxComponents = [];
          if (sizePart.includes('25l + 25l') && aux4) {
            auxComponents = [aux4];
          } else if (sizePart.includes('35l + 35l') && aux5) {
            auxComponents = [aux5];
          } else if (sizePart.includes('35l + 25l') && aux4 && aux5) {
            auxComponents = [aux4, aux5];
          }

          if (!auxComponents.length) return;

          const allowedLists = auxComponents.map(({ comp, idx }) => {
            const originalFallback = originalQuantityConfig[idx]
              ? originalQuantityConfig[idx].allowed_quantities
              : comp.allowed_quantities;
            return getAllowedQuantitiesFor(
              variant.id,
              comp.component_product_handle,
              idx,
              originalFallback
            );
          }
          );
          const commonAllowed = allowedLists.reduce((acc, list) => {
            if (!acc) return list;
            return acc.filter(q => list.includes(q));
          }, null) || [];

          const nonZeroAllowed = commonAllowed.filter(q => q > 0);
          nonZeroAllowed.forEach(qty => {
            const auxTags = auxComponents
              .map(({ comp }) => `${comp.component_product_handle.toLowerCase()}:${color}|qty:${qty}`)
              .join(', ');
            tagLines.push(`[${baseTag}, ${auxTags}]`);
          });
        });

        // Compact helper: "Two Aux" tag list (one line, copy/paste)
        const findAuxColorFor = (component, baseColor) => {
          if (!component || !component.variants || !component.variants.length) return baseColor;
          const match = component.variants.find(v => {
            const title = (v.title || '').toLowerCase();
            return title.includes(baseColor.toLowerCase());
          });
          if (!match) return baseColor;
          const parts = (match.title || '').toLowerCase().split('/').map(s => s.trim());
          return parts[0] || baseColor;
        };

        // Combined tags for current Aux selection (copy/paste ready)
        const buildCombinedForQty = (displayQty) => {
          const lines = [];
          variantsForColor.forEach(variant => {
            const parts = (variant.title || '').toLowerCase().split(' / ').map(s => s.trim());
            const sizePart = parts[1] || '';
            const baseTag = `${baseHandle}:${color}|${sizePart}`;

            let auxComponents = [];
            if (sizePart.includes('25l + 25l') && aux4) {
              auxComponents = [aux4];
            } else if (sizePart.includes('35l + 35l') && aux5) {
              auxComponents = [aux5];
            } else if (sizePart.includes('35l + 25l') && aux4 && aux5) {
              auxComponents = [aux4, aux5];
            }

            if (!auxComponents.length) return;

            // Offset uses halved quantities (2 -> 1, 4 -> 2)
            const perComponentQty = (auxComponents.length > 1 && displayQty > 0)
              ? Math.max(1, Math.floor(displayQty / 2))
              : displayQty;

            const auxTags = auxComponents
              .map(({ comp }) => {
                const auxColor = findAuxColorFor(comp, color);
                return `${comp.component_product_handle.toLowerCase()}:${auxColor}|qty:${perComponentQty}`;
              })
              .join(', ');

            lines.push(`[${baseTag}, ${auxTags}]`);
          });

          return lines;
        };

        const currentQty = sharedAuxSelectedValue;
        const combinedLines = buildCombinedForQty(currentQty);
        if (combinedLines.length) {
          const combined = combinedLines.map(line => line.replace(/^\[|\]$/g, '')).join(', ');
          const combinedSignature = `[${combined}]`;
          if (shouldLogAltTag(combinedSignature)) {
            altTagLog(`Image Description ${combinedSignature}`);
          }
          lastNavigationSignature = combinedSignature;
        }

        if (isAltTagVerbose) {
          const twoAuxLines = buildCombinedForQty(2);
          if (twoAuxLines.length) {
            const twoAuxCombined = twoAuxLines.map(line => line.replace(/^\[|\]$/g, '')).join(', ');
            altTagLog(`Combined "Two Aux" alt tag for ${color}:`);
            altTagLog(`Image Description [${twoAuxCombined}]`);
          }

          const fourAuxLines = buildCombinedForQty(4);
          if (fourAuxLines.length) {
            const fourAuxCombined = fourAuxLines.map(line => line.replace(/^\[|\]$/g, '')).join(', ');
            altTagLog(`Combined "Four Aux" alt tag for ${color}:`);
            altTagLog(`Image Description [${fourAuxCombined}]`);
          }
        }
      }

      // Default single-tag output
      if (!showCombinedAltTag || lastNavigationSignature === altTagFormat) {
        if (shouldLogAltTag(altTagFormat)) {
          altTagLog(`Image Description ${altTagFormat}`);
        }
      }

      // Handles to ignore during image matching (non-visual components)
      const ignoreImageMatchHandles = new Set(
        [
          'the-gnoblin',
          ...(Array.isArray(window.bundleImageIgnoreHandles) ? window.bundleImageIgnoreHandles : []),
          ...bundleConfig.components
            .filter(component => component.ignore_image_match)
            .map(component => component.component_product_handle)
        ]
          .filter(Boolean)
          .map(handle => handle.toLowerCase())
      );

      const getTagHandle = (tag) => {
        const normalized = (tag || '').toLowerCase().trim();
        if (!normalized) return null;
        if (normalized.includes(':')) return normalized.split(':')[0];
        if (normalized.includes('|')) return normalized.split('|')[0];
        return normalized;
      };

      // Conflict warning: only when current alt tag matches multiple images
      const signatureTags = (lastNavigationSignature || altTagFormat)
        .replace(/^\[|\]$/g, '')
        .split(',')
        .map(tag => tag.trim())
        .filter(tag => tag.length > 0)
        .filter(tag => !ignoreImageMatchHandles.has(getTagHandle(tag)));
      let exactSignatureMatch = null;
      if (window.bundleBaseProduct && Array.isArray(window.bundleBaseProduct.images) && signatureTags.length) {
        const matchingImages = window.bundleBaseProduct.images.filter(image => {
          if (!image.component_tags || !Array.isArray(image.component_tags)) return false;
          const filteredComponentTags = image.component_tags
            .filter(tag => !ignoreImageMatchHandles.has(getTagHandle(tag)));
          if (!signatureTags.every(tag => filteredComponentTags.includes(tag))) return false;
          return filteredComponentTags.length === signatureTags.length;
        });
        if (matchingImages.length === 1) {
          const matchedImage = matchingImages[0];
          const matchedIndex = window.bundleBaseProduct.images.findIndex(image => image.id === matchedImage.id);
          if (matchedIndex >= 0) {
            exactSignatureMatch = {
              imageIndex: matchedIndex,
              imageId: matchedImage.id
            };
          }
        }
        if (matchingImages.length > 1) {
          altTagWarn(
            `⚠️ Alt tag matches multiple images (${matchingImages.length})`,
            matchingImages.map(image => image.id)
          );
        }
      }
      
      // Find matching image in gallery
      // Strategy: Check each image to see how many components it matches
      // Prioritize images that match more components
      // When no optional components are selected (quantity 0), prefer images without component tags
      let bestMatch = {
        imageIndex: -1,
        matchingTag: null,
        matchType: null,
        componentMatches: 0, // How many components this image matches
        isExact: false // Whether image has exactly the same number of tags as selected components
      };
      if (exactSignatureMatch) {
        bestMatch = {
          imageIndex: exactSignatureMatch.imageIndex,
          matchingTag: signatureTags.join(', '),
          matchType: 'exact-signature',
          componentMatches: signatureTags.length,
          isExact: true
        };
      }
      
      // Check if we only have base component (no optional components selected)
      const hasOnlyBaseComponent = baseComponentVariant !== null && selectedComponentVariants.length === 0;
      const hasBaseOnlyTagMatch = hasOnlyBaseComponent &&
        window.bundleBaseProduct &&
        Array.isArray(window.bundleBaseProduct.images) &&
        signatureTags.length &&
        window.bundleBaseProduct.images.some(image => {
          if (!image.component_tags || !Array.isArray(image.component_tags)) return false;
          const filteredComponentTags = image.component_tags
            .filter(tag => !ignoreImageMatchHandles.has(getTagHandle(tag)));
          if (!signatureTags.every(tag => filteredComponentTags.includes(tag))) return false;
          return filteredComponentTags.length === signatureTags.length;
        });
      
      // If we only have base component and no tag matches, use the variant's featured image
      if (hasOnlyBaseComponent && !hasBaseOnlyTagMatch && window.bundleBaseProduct && window.bundleBaseProduct.variants) {
        const baseComponentIndex = bundleConfig.base_component_index;
        const componentEl = bundleBuilder.querySelector(`.bundle-component[data-component-index="${baseComponentIndex}"]`);
        if (componentEl) {
          const hiddenSelect = componentEl.querySelector(`#variant-select-${baseComponentIndex}`);
          if (hiddenSelect && hiddenSelect.value) {
            const variantId = parseInt(hiddenSelect.value);
            const baseVariant = window.bundleBaseProduct.variants.find(v => v.id === variantId);
            if (baseVariant && baseVariant.featured_image_index >= 0) {
              debugLog(`Using base variant's featured image index: ${baseVariant.featured_image_index}, image ID: ${baseVariant.featured_image_id}`);
              
              // Wait for Flickity to be ready before navigating
        const navigateToBaseVariantImage = (retryCount = 0) => {
          if (runId !== navigationRunId) {
            debugLog('Skipping stale base variant navigation');
            debugGroupEnd();
            return;
          }
                if (retryCount > 20) {
                  errorLog('⚠️ Failed to navigate after 20 retries');
                  debugGroupEnd();
                  return;
                }
                
                const flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
                if (!flickityInstance) {
                  setTimeout(() => navigateToBaseVariantImage(retryCount + 1), 50);
                  return;
                }
                
                if (!flickityInstance.cells || !Array.isArray(flickityInstance.cells) || flickityInstance.cells.length === 0) {
                  setTimeout(() => navigateToBaseVariantImage(retryCount + 1), 50);
                  return;
                }
                
                // Get fresh reference to gallery to ensure we have current DOM state
                const { $gallery: $galleryFresh } = getGalleryElements();
                const $targetSlide = $galleryFresh.find(`[data-image-id="${baseVariant.featured_image_id}"]`).closest('.gallery-cell');
                
                if (isDebugEnabled()) {
                  infoLog('📸 navigateToOptionalComponentImage base fallback', {
                    variantId,
                    featured_image_id: baseVariant.featured_image_id,
                    featured_image_index: baseVariant.featured_image_index,
                    targetSlideFound: $targetSlide.length > 0
                  });
                }
                
                // Debug: Check what Flickity currently shows
                const currentSelected = flickityInstance.selectedElement;
                const currentImageId = currentSelected && currentSelected.querySelector('[data-image-id]')
                  ? currentSelected.querySelector('[data-image-id]').dataset.imageId
                  : 'none';
                
                infoLog(`🖼️ Navigating to base variant image:`);
                infoLog(`   Target: ID=${baseVariant.featured_image_id}, index=${baseVariant.featured_image_index}`);
                infoLog(`   Current Flickity: index=${flickityInstance.selectedIndex}, imageId=${currentImageId}`);
                infoLog(`   Found target slide: ${$targetSlide.length > 0}`);
                
                let navigationSuccess = false;
                
                if ($targetSlide.length) {
                  const baseImageData = window.bundleBaseProduct.images[baseVariant.featured_image_index];
                  normalizeGalleryMediaSources(baseImageData);
                  if (selectFlickityCell(flickityInstance, $targetSlide[0], baseVariant.featured_image_index, baseVariant.featured_image_id)) {
                    infoLog(`✅ Successfully navigated to base variant featured image (ID: ${baseVariant.featured_image_id})`);
                    debugLog('✅ Successfully navigated to base variant featured image');
                    navigationSuccess = true;
                  } else {
                    warnLog(`⚠️ Failed to select cell for base variant image ID ${baseVariant.featured_image_id}, retrying with index`);
                    // Fallback: try selecting by index only
                    if (flickityInstance.cells && flickityInstance.cells.length > baseVariant.featured_image_index) {
                      try {
                        flickityInstance.select(baseVariant.featured_image_index, false, true);
                        syncThumbnails(baseVariant.featured_image_id, baseVariant.featured_image_index);
                        infoLog(`✅ Successfully navigated using index fallback (index: ${baseVariant.featured_image_index})`);
                        debugLog('✅ Successfully navigated using index fallback');
                        navigationSuccess = true;
                      } catch (err) {
                        errorLog('⚠️ Index fallback also failed:', err);
                      }
                    }
                  }
                } else {
                  warnLog(`⚠️ Target slide not found for image ID ${baseVariant.featured_image_id}, trying index fallback`);
                  // Fallback: try selecting by index only
                  if (flickityInstance.cells && flickityInstance.cells.length > baseVariant.featured_image_index) {
                    try {
                      flickityInstance.select(baseVariant.featured_image_index, false, true);
                      syncThumbnails(baseVariant.featured_image_id, baseVariant.featured_image_index);
                      infoLog(`✅ Successfully navigated using index fallback (no slide element, index: ${baseVariant.featured_image_index})`);
                      debugLog('✅ Successfully navigated using index fallback (no slide element)');
                      navigationSuccess = true;
                    } catch (err) {
                      errorLog('⚠️ Index fallback also failed:', err);
                    }
                  }
                }
                
                if (!navigationSuccess) {
                  errorLog(`❌ All navigation attempts failed for base variant image ID ${baseVariant.featured_image_id}`);
                }
                
                debugGroupEnd();
                return;
              };
              
              navigateToBaseVariantImage();
              return;
            }
          }
        }

      }
      
      // Search through all images
      if (bestMatch.imageIndex < 0) {
      for (let i = 0; i < window.bundleBaseProduct.images.length; i++) {
        const imageData = window.bundleBaseProduct.images[i];
        let componentTags = imageData.component_tags;
        
        // For images with optional components, skip images without component tags
        if (!componentTags || componentTags.length === 0) continue;
        
        // Verify componentTags is an array
        if (!Array.isArray(componentTags)) {
          if (typeof componentTags === 'string') {
            try {
              const parsed = JSON.parse(componentTags);
              if (Array.isArray(parsed)) componentTags = parsed;
              else continue;
            } catch (e) {
              continue;
            }
          } else {
            continue;
          }
        }
        
        // Check how many selected components this image matches
        let componentMatches = 0;
        let bestMatchTypeForImage = null;
        let matchedTags = [];
        
        // Filter out ignored handles from image tags before matching
        componentTags = componentTags.filter(tag => !ignoreImageMatchHandles.has(getTagHandle(tag)));
        if (!componentTags.length) continue;

        // Count total tags in image (to prefer images with exact number of matches)
        const totalTagsInImage = Array.isArray(componentTags) ? componentTags.length : 1;
        
        // Create combined array that includes base component variant (if present) and selected component variants
        const allVariantsToMatch = [];
        if (baseComponentVariant) {
          allVariantsToMatch.push(baseComponentVariant);
        }
        allVariantsToMatch.push(
          ...selectedComponentVariants.filter(v => {
            const handle = (v.productHandle || '').toLowerCase();
            return !ignoreImageMatchHandles.has(handle);
          })
        );
        
        // Calculate expected total tags (base + selected components)
        const expectedTotalTags = allVariantsToMatch.length;
        
        for (const selectedVariant of allVariantsToMatch) {
        // Check if this image has a tag matching this component
          for (let tagIdx = 0; tagIdx < componentTags.length; tagIdx++) {
            const tag = componentTags[tagIdx];
            const tagLower = tag.toLowerCase().trim();
            
            // Support two formats:
            // 1. handle|color|size (original)
            // 2. handle:color|size or handle:color|qty:2 (new format with colon)
            let tagHandle, tagVariantParts;
            
            if (tagLower.includes(':')) {
              // New format: handle:color|size or handle:color|qty:2
              const colonIndex = tagLower.indexOf(':');
              tagHandle = tagLower.substring(0, colonIndex);
              const afterColon = tagLower.substring(colonIndex + 1);
              tagVariantParts = afterColon.split('|');
            } else {
              // Original format: handle|color|size
              const tagParts = tagLower.split('|');
              tagHandle = tagParts[0];
              tagVariantParts = tagParts.slice(1);
            }
            
            // Match by handle
            if (tagHandle === (selectedVariant.productHandle || '').toLowerCase()) {
              
              // Check if tag includes quantity
              // Support formats: "qty:2" or just "2"
              let tagQuantity = null;
              let tagVariantPartsWithoutQty = tagVariantParts;
              
              const lastPart = tagVariantParts[tagVariantParts.length - 1];
              
              // Check for "qty:2" format
              if (lastPart && lastPart.startsWith('qty:')) {
                const qtyValue = lastPart.substring(4);
                if (/^\d+$/.test(qtyValue)) {
                  tagQuantity = parseInt(qtyValue);
                  tagVariantPartsWithoutQty = tagVariantParts.slice(0, -1);
                }
              } 
              // Check for pure number format (original)
              else {
                const isPureNumber = /^\d+$/.test(lastPart);
                const tagHasQuantity = isPureNumber && tagVariantParts.length > 1;
                if (tagHasQuantity) {
                  tagQuantity = parseInt(lastPart);
                  tagVariantPartsWithoutQty = tagVariantParts.slice(0, -1);
                }
              }
              
              // If component has quantity, check if it matches tag quantity
              // Base component variants don't have quantities, so skip quantity check for them
              if (selectedVariant.quantity !== null && selectedVariant.quantity !== undefined) {
                if (tagQuantity !== null && tagQuantity !== selectedVariant.quantity) {
                  continue; // Quantity doesn't match, skip this tag
                }
              } else if (tagQuantity !== null && selectedVariant !== baseComponentVariant) {
                // Tag has quantity but component doesn't (and it's not the base component), skip this tag
                continue;
              }
              
              // Check for exact color + size match first (highest priority)
              const exactMatch = tagVariantPartsWithoutQty.join('|') === selectedVariant.variantKey;
              
              // Check for color + size match (order doesn't matter)
              const colorSizeMatch = selectedVariant.variantColor && selectedVariant.variantSize &&
                tagVariantPartsWithoutQty.includes(selectedVariant.variantColor) &&
                tagVariantPartsWithoutQty.includes(selectedVariant.variantSize);
              
              // Check for color-only match (for aux pox which might not have size)
              const colorOnlyMatch = selectedVariant.variantColor && !selectedVariant.variantSize &&
                tagVariantPartsWithoutQty.includes(selectedVariant.variantColor);
              
              // Check for size-only match (fallback)
              const sizeOnlyMatch = selectedVariant.variantSize &&
                tagVariantPartsWithoutQty.includes(selectedVariant.variantSize) &&
                tagVariantPartsWithoutQty.length === 1;
              
              // Check for partial match (strict equality only; avoid substring collisions like "black" vs "triple black")
              const tagKey = tagVariantPartsWithoutQty.join('|');
              const partialMatch =
                tagKey === selectedVariant.variantKey ||
                (selectedVariant.variantKeySimple && tagKey === selectedVariant.variantKeySimple);
              
              const variantMatches = exactMatch || colorSizeMatch || colorOnlyMatch || sizeOnlyMatch || partialMatch;
              
              if (variantMatches) {
                // Determine match type
                const matchType = exactMatch ? 'exact' : (colorSizeMatch ? 'color+size' : (colorOnlyMatch ? 'color-only' : 'size-only'));
                
                componentMatches++;
                matchedTags.push(tag);
                
                // Track best match type for this image
                if (!bestMatchTypeForImage || 
                    (matchType === 'exact') ||
                    (matchType === 'color+size' && bestMatchTypeForImage !== 'exact') ||
                    (matchType === 'color-only' && bestMatchTypeForImage !== 'exact' && bestMatchTypeForImage !== 'color+size')) {
                  bestMatchTypeForImage = matchType;
                }
                
                break; // Found a match for this component, move to next component
              }
            }
          }
        }
        
        // Only consider images that match all selected components (base + optionals)
        if (componentMatches === expectedTotalTags) {
          // Prefer images that match exactly the number of expected components (base + selected, no extra tags)
          const exactComponentMatch = componentMatches === expectedTotalTags && totalTagsInImage === expectedTotalTags;
          
          const shouldUseThisMatch = 
            bestMatch.imageIndex < 0 || // No match yet
            componentMatches > bestMatch.componentMatches || // More component matches
            (exactComponentMatch && !bestMatch.isExact) || // Exact match beats non-exact
            (exactComponentMatch && bestMatch.isExact && componentMatches === bestMatch.componentMatches && 
             ((bestMatchTypeForImage === 'exact' && bestMatch.matchType !== 'exact') ||
              (bestMatchTypeForImage === 'color+size' && bestMatch.matchType !== 'exact' && bestMatch.matchType !== 'color+size') ||
              (bestMatchTypeForImage === 'color-only' && bestMatch.matchType === 'size-only'))) || // Better match type within exact matches
            (!exactComponentMatch && !bestMatch.isExact && componentMatches === bestMatch.componentMatches && 
             ((bestMatchTypeForImage === 'exact' && bestMatch.matchType !== 'exact') ||
              (bestMatchTypeForImage === 'color+size' && bestMatch.matchType !== 'exact' && bestMatch.matchType !== 'color+size') ||
              (bestMatchTypeForImage === 'color-only' && bestMatch.matchType === 'size-only'))); // Better match type within non-exact matches
          
          debugLog(`Image ${i}: matches ${componentMatches}/${expectedTotalTags} components (exact=${exactComponentMatch}), type=${bestMatchTypeForImage}, tags="${matchedTags.join(', ')}" (total tags in image: ${totalTagsInImage}), current best=${bestMatch.imageIndex >= 0 ? `img[${bestMatch.imageIndex}] (exact=${bestMatch.isExact})` : 'none'}, shouldUse=${shouldUseThisMatch}`);
          
          if (shouldUseThisMatch) {
            bestMatch = {
              imageIndex: i,
              matchingTag: matchedTags.join(', '),
              matchType: bestMatchTypeForImage,
              componentMatches: componentMatches,
              isExact: exactComponentMatch
            };
            debugLog(`✅ Match [${bestMatchTypeForImage}]: img[${i}] tags="${matchedTags.join(', ')}" (${componentMatches}/${expectedTotalTags} components, exact match: ${exactComponentMatch})`);
          }
        }
      }
      }
      
      // Use best match found
      const matchingImageIndex = bestMatch.imageIndex;
      const matchingTag = bestMatch.matchingTag;
      const bestMatchType = bestMatch.matchType;
      
      // Navigate to matching image if found
      if (matchingImageIndex >= 0) {
        const imageData = window.bundleBaseProduct.images[matchingImageIndex];
        debugLog(`Navigating: idx=${matchingImageIndex} id=${imageData.id} tag="${matchingTag}" type=${bestMatchType}`);
        
        // Wait for Flickity to be ready before navigating
        const navigateToMatchingImage = (retryCount = 0) => {
          if (runId !== navigationRunId) {
            debugLog('Skipping stale component-tag navigation');
            debugGroupEnd();
            return;
          }
          if (retryCount > 20) {
            errorLog('⚠️ Failed to navigate after 20 retries');
            debugGroupEnd();
            return;
          }
          
          const flickityInstance = window.Flickity && window.Flickity.data($gallery[0]);
          if (!flickityInstance) {
            setTimeout(() => navigateToMatchingImage(retryCount + 1), 50);
            return;
          }
          
          if (!flickityInstance.cells || !Array.isArray(flickityInstance.cells) || flickityInstance.cells.length === 0) {
            setTimeout(() => navigateToMatchingImage(retryCount + 1), 50);
            return;
          }
          
          // Get fresh reference to gallery to ensure we have current DOM state
          const { $gallery: $galleryFresh } = getGalleryElements();
          const $targetSlide = $galleryFresh.find(`[data-image-id="${imageData.id}"]`).closest('.gallery-cell');
          
          // Debug: Check what Flickity currently shows
          const currentSelected = flickityInstance.selectedElement;
          const currentImageId = currentSelected && currentSelected.querySelector('[data-image-id]')
            ? currentSelected.querySelector('[data-image-id]').dataset.imageId
            : 'none';
          
          infoLog(`🖼️ Navigating to matching image:`);
          infoLog(`   Target: ID=${imageData.id}, index=${matchingImageIndex}, tag="${matchingTag}"`);
          infoLog(`   Current Flickity: index=${flickityInstance.selectedIndex}, imageId=${currentImageId}`);
          infoLog(`   Found target slide: ${$targetSlide.length > 0}`);
          
          normalizeGalleryMediaSources(imageData);
          
          let navigationSuccess = false;
          
          if ($targetSlide.length) {
            if (selectFlickityCell(flickityInstance, $targetSlide[0], matchingImageIndex, imageData.id)) {
              infoLog(`✅ Successfully navigated to image (ID: ${imageData.id}, index: ${matchingImageIndex})`);
              debugLog('✅ Navigated');
              navigationSuccess = true;
            } else {
              warnLog(`⚠️ Failed to select cell for image ID ${imageData.id}, retrying with index`);
              // Fallback: try selecting by index only
              if (flickityInstance.cells && flickityInstance.cells.length > matchingImageIndex) {
                try {
                  flickityInstance.select(matchingImageIndex, false, true);
                  syncThumbnails(imageData.id, matchingImageIndex);
                  infoLog(`✅ Successfully navigated using index fallback (index: ${matchingImageIndex})`);
                  debugLog('✅ Navigated using index fallback');
                  navigationSuccess = true;
                } catch (err) {
                  errorLog('⚠️ Index fallback also failed:', err);
                }
              }
            }
          } else {
            warnLog(`⚠️ Target slide not found for image ID ${imageData.id}, trying index fallback`);
            // Fallback: try selecting by index only
            if (flickityInstance.cells && flickityInstance.cells.length > matchingImageIndex) {
              try {
                flickityInstance.select(matchingImageIndex, false, true);
                syncThumbnails(imageData.id, matchingImageIndex);
                infoLog(`✅ Successfully navigated using index fallback (no slide element, index: ${matchingImageIndex})`);
                debugLog('✅ Navigated using index fallback (no slide element found)');
                navigationSuccess = true;
              } catch (err) {
                errorLog('⚠️ Index fallback also failed:', err);
              }
            }
          }
          
          if (!navigationSuccess) {
            errorLog(`❌ All navigation attempts failed for image ID ${imageData.id}`);
          }
        };
        
        navigateToMatchingImage();
      } else {
        debugWarn('❌ No matching image found');
        logFlickityState('navigateToOptionalComponentImage:no-match');

        // Fallback: navigate to current base variant featured image
        const baseIdx = bundleConfig.base_component_index;
        const baseCompEl = bundleBuilder.querySelector(`.bundle-component[data-component-index="${baseIdx}"]`);
        const baseSelect = baseCompEl && baseCompEl.querySelector(`#variant-select-${baseIdx}`);
        const baseVariantId = baseSelect ? parseInt(baseSelect.value, 10) : null;
        const baseVariant = baseVariantId && window.bundleBaseProduct && window.bundleBaseProduct.variants
          ? window.bundleBaseProduct.variants.find(v => v.id === baseVariantId)
          : null;
        if (baseVariant && baseVariant.featured_media && baseVariant.featured_media.id) {
          debugLog('Fallback to base variant featured media', {
            baseVariantId,
            mediaId: baseVariant.featured_media.id,
            imageId: baseVariant.featured_image_id,
            imageIndex: baseVariant.featured_image_index
          });
          switchProductImage(baseVariant.featured_media.id);
        }
      }
      
      debugGroupEnd();
    }

    // Expose navigation function globally so Fancybox close handler can call it
    window.navigateToOptionalComponentImage = navigateToOptionalComponentImage;
    window.scheduleNavigateToOptionalComponentImage = scheduleNavigateToOptionalComponentImage;

    // Handle swatch clicks - sync with hidden select and update variant
    bundleBuilder.addEventListener('click', function(e) {
      const swatchEl = e.target.closest('.swatch-element');
      debugGroup('🖱️ Swatch Click');
      
      if (!swatchEl) {
        debugLog('Not a swatch click');
        debugGroupEnd();
        return;
      }
      
      if (swatchEl.classList.contains('soldout')) {
        // Allow soldout clicks on the base component so Notify Me can be shown.
        // Block soldout clicks on add-on / optional components (nothing useful happens there).
        const soldoutComponentEl = swatchEl.closest('.bundle-component');
        const soldoutComponentIndex = soldoutComponentEl ? parseInt(soldoutComponentEl.dataset.componentIndex) : -1;
        const soldoutComponent = soldoutComponentIndex >= 0 ? bundleConfig.components[soldoutComponentIndex] : null;
        if (!soldoutComponent || !soldoutComponent.is_base) {
          debugLog('Swatch is sold out (non-base component), ignoring');
          debugGroupEnd();
          return;
        }
        debugLog('Swatch is sold out but is base component — allowing selection for Notify Me');
      }
      
      const componentEl = swatchEl.closest('.bundle-component');
      debugLog('Component element found:', !!componentEl);
      if (!componentEl) {
        debugGroupEnd();
        return;
      }
      
      const componentIndex = parseInt(componentEl.dataset.componentIndex);
      const component = bundleConfig.components[componentIndex];
      const hiddenSelect = componentEl.querySelector(`#variant-select-${componentIndex}`);
      
      debugLog('Component index:', componentIndex);
      debugLog('Component role:', component.role);
      debugLog('Component is_base:', component.is_base);
      debugLog('Component product handle:', component.component_product_handle);
      debugLog('Hidden select found:', !!hiddenSelect);
      debugLog('Hidden select tag:', hiddenSelect ? hiddenSelect.tagName : 'N/A');
      debugLog('Clicked swatch value:', swatchEl.dataset.value);
      debugLog('Clicked swatch data-id:', swatchEl.dataset.id);
      
      if (!hiddenSelect || hiddenSelect.tagName !== 'SELECT') {
        debugWarn('⚠️ Hidden select not found or not a SELECT element');
        debugGroupEnd();
        return;
      }
      
      // Get the clicked swatch's option index and value FIRST
      const clickedOptionIndex = parseInt(swatchEl.closest('.swatch').dataset.optionIndex);
      const clickedValue = swatchEl.dataset.value;
      if (!clickedValue) {
        debugWarn('⚠️ Clicked swatch is missing a data-value; ignoring click');
        debugGroupEnd();
        return;
      }
      
      // Get all selected options for this component (including the one just clicked)
      // Check both checked radios AND swatches with selected class (in case radio isn't checked)
      const selectedOptions = {};
      componentEl.querySelectorAll('.swatch').forEach(swatchGroup => {
        const optionIndex = parseInt(swatchGroup.dataset.optionIndex);
        
        // First, check for checked radio
        const checkedRadio = swatchGroup.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          selectedOptions[optionIndex] = checkedRadio.value;
        } else {
          // Fallback: check for swatch with selected class
          const selectedSwatch = swatchGroup.querySelector('.swatch-element.selected');
          if (selectedSwatch && selectedSwatch.dataset.value) {
            selectedOptions[optionIndex] = selectedSwatch.dataset.value;
          }
        }
      });
      
      // IMPORTANT: Add the clicked value to selectedOptions BEFORE checking the radio
      // This ensures we have the complete selection when matching variants
      selectedOptions[clickedOptionIndex] = clickedValue;
      
      debugLog('Built selectedOptions:', selectedOptions);
      
      // Find the radio input - it's the previous sibling of the swatch-element
      const radioInput = swatchEl.previousElementSibling;
      
      // Also try finding by value if previous sibling isn't a radio
      let radioToCheck = null;
      if (radioInput && radioInput.type === 'radio' && radioInput.value === clickedValue) {
        radioToCheck = radioInput;
      } else {
        // Find by value in the same swatch group
        const swatchGroup = swatchEl.closest('.swatch');
        const escapedClickedValue = clickedValue.replace(/"/g, '\\"');
        radioToCheck = swatchGroup.querySelector(`input[type="radio"][value="${escapedClickedValue}"]`);
      }
      
      if (radioToCheck) {
        // Uncheck all other radios in this option group first
        const swatchGroup = swatchEl.closest('.swatch');
        swatchGroup.querySelectorAll('input[type="radio"]').forEach(radio => {
          radio.checked = false;
          // Remove selected class from sibling swatch-element
          const siblingSwatch = radio.nextElementSibling;
          if (siblingSwatch && siblingSwatch.classList.contains('swatch-element')) {
            siblingSwatch.classList.remove('selected');
          }
        });
        
        // Check the clicked swatch's radio
        radioToCheck.checked = true;
        
        // Add selected class to swatch element for visual feedback
        swatchEl.classList.add('selected');
        
        // Trigger change event so CSS and other listeners can react
        const changeEvent = new Event('change', { bubbles: true });
        radioToCheck.dispatchEvent(changeEvent);
      }
      
      // Update selectedOptions with the clicked value
      selectedOptions[clickedOptionIndex] = clickedValue;
      
      // If we're missing option values (e.g., color wasn't explicitly selected but is filtered),
      // check for visible swatches and auto-select the only visible one
      const swatchGroups = componentEl.querySelectorAll('.swatch');
      swatchGroups.forEach(swatchGroup => {
        const optionIdx = parseInt(swatchGroup.dataset.optionIndex);
        // If this option isn't in selectedOptions yet
        if (selectedOptions[optionIdx] === undefined) {
          // Find visible (not hidden) swatches for this option
          const visibleSwatches = Array.from(swatchGroup.querySelectorAll('.swatch-element')).filter(
            sw => sw.offsetParent !== null && !sw.classList.contains('hidden')
          );
          
          // If only one visible swatch, auto-select it
          if (visibleSwatches.length === 1) {
            const autoSwatch = visibleSwatches[0];
            const autoValue = autoSwatch.dataset.value;
            if (!autoValue) return; // Skip if missing value
            selectedOptions[optionIdx] = autoValue;
            
            // Also check the radio for this swatch
            const escapedAutoValue = autoValue.replace(/"/g, '\\"');
            const autoRadio = swatchGroup.querySelector(`input[type="radio"][value="${escapedAutoValue}"]`);
            if (autoRadio && !autoRadio.checked) {
              autoRadio.checked = true;
              autoSwatch.classList.add('selected');
            }
          }
        }
      });
      
      // Find variant that matches all selected options
      const allOptions = Array.from(hiddenSelect.options);
      let matchingVariant = null;
      
      debugLog('Matching variant - selectedOptions:', selectedOptions);
      
      // Try to find variant by matching all option values
      for (const option of allOptions) {
        if (!option.value) continue; // Skip "Choose an option..."
        
        // Parse variant title to get option values (e.g., "Grey / 8L" -> ["Grey", "8L"])
        const variantTitle = option.textContent.trim();
        const variantOptionValues = variantTitle.split(' / ');
        
        debugLog(`Checking variant "${variantTitle}" with values:`, variantOptionValues);
        
        // Check if all selected options match this variant (case-insensitive comparison)
        let allMatch = true;
        for (let i = 0; i < variantOptionValues.length; i++) {
          const variantValue = variantOptionValues[i].trim();
          const selectedValue = selectedOptions[i];
          
          // If we have a selected value for this option, it must match (case-insensitive)
          if (selectedValue !== undefined && selectedValue.toLowerCase() !== variantValue.toLowerCase()) {
            debugLog(`  Option ${i}: "${selectedValue}" !== "${variantValue}" - no match`);
            allMatch = false;
            break;
          } else if (selectedValue !== undefined) {
            debugLog(`  Option ${i}: "${selectedValue}" === "${variantValue}" - match`);
          }
        }
        
        // Also check that we have selections for all options
        if (allMatch && Object.keys(selectedOptions).length === variantOptionValues.length) {
          debugLog(`✅ Found matching variant: ${variantTitle} (ID: ${option.value})`);
          matchingVariant = {
            id: parseInt(option.value),
            option: option
          };
          break;
        } else if (allMatch) {
          debugLog(`  Partial match but option count mismatch: selected=${Object.keys(selectedOptions).length}, variant=${variantOptionValues.length}`);
        }
      }
      
      // Fallback: use swatch's data-id if no match found (for single-option products)
      if (!matchingVariant) {
        const swatchVariantId = parseInt(swatchEl.dataset.id);
        if (swatchVariantId) {
          const option = allOptions.find(opt => parseInt(opt.value) === swatchVariantId);
          if (option) {
            matchingVariant = {
              id: swatchVariantId,
              option: option
            };
          }
        }
      }
      
      // If we found a matching variant, update the select
      if (matchingVariant && matchingVariant.option) {
        hiddenSelect.value = matchingVariant.option.value;
        selectedVariants[componentIndex] = matchingVariant.id;
        
        // Trigger change event to apply variant rules
        hiddenSelect.dispatchEvent(new Event('change'));
        
        // Only apply variant rules if this is the base component
        // Rules are triggered by base component variants, not dependent component variants
        if (component.is_base) {
          // Also trigger variant rules manually in case change event doesn't propagate
          debugLog('Calling applyVariantRules with variant ID:', matchingVariant.id);
          debugLog('Variant title:', matchingVariant.option.textContent.trim());
          debugLog('Available trigger variant IDs in rules:', bundleConfig.variant_rules.map(r => r.trigger_variant_id));
          
          // Debug: Show all base product variants if this is the base component
          if (isDebugEnabled() && window.bundleBaseProduct && window.bundleBaseProduct.variants) {
            debugLog('=== ALL BASE PRODUCT VARIANTS ===');
            window.bundleBaseProduct.variants.forEach((v, idx) => {
              debugLog(`Variant ${idx}:`, {
                id: v.id,
                title: v.title,
                options: v.options,
                featured_image_id: v.featured_image_id,
                featured_image_index: v.featured_image_index
              });
            });
            debugLog('=== END BASE PRODUCT VARIANTS ===');
          }
          
          // Apply variant rules (this will auto-select dependent components)
          applyVariantRules(componentIndex, matchingVariant.id, bundleConfig);
          
          // After variant rules are applied and dependent components are auto-selected,
          // navigate to the best matching image (component-tagged or featured image)
          // This function handles both cases: uses featured image if only base component,
          // or finds component-tagged image if optional components are selected
          setTimeout(() => {
            scheduleNavigateToOptionalComponentImage();
          }, 150);
        } else {
          debugLog(`Skipping applyVariantRules for component ${componentIndex} (not base component)`);
          
          // If this is an optional/required component, navigate to tagged image
          if (component.role === 'optional' || component.role === 'accessory' || component.role === 'required') {
            setTimeout(() => {
              scheduleNavigateToOptionalComponentImage();
            }, 100);
          }
        }
        
        // Check if bundle is ready
        checkBundleReady();
        
        // Update price display
        updateComponentPriceDisplay(componentIndex);
        updateComponentDiscountDisplay(componentIndex);
        updateTotalBundlePrice();
      }
    });
    
    // Update prices when swatch is clicked (handled by event listener)
    bundleBuilder.addEventListener('change', function(e) {
      const variantSelect = e.target.closest('.bundle-variant-select');
      if (variantSelect && variantSelect.dataset.componentIndex) {
        const componentIndex = parseInt(variantSelect.dataset.componentIndex);
        updateComponentPriceDisplay(componentIndex);
        updateComponentDiscountDisplay(componentIndex);
        updateTotalBundlePrice();
      }
    });
    
    debugLog('✅ Bundle builder initialized');
    debugGroupEnd();
    
    // Initial check
    checkBundleReady();
  }
})();


